<template>
  <div v-resize="onResize">
    <v-dialog scrollable v-model="showEditNode" persistent max-width="600">
      <v-card v-if="selectedNode && showEditNode">
        <v-card-text :key="selectedNode.id">
          <intent-manage
            v-model="selectedNode"
            @onCancel="onCancelIntent"
            @onSave="onSaveIntent"
          ></intent-manage>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showEditApi" persistent max-width="1000">
      <v-card v-if="selectedNode && showEditApi && !loadingApiList">
        <v-card-text :key="selectedNode.id">
          <api-manage v-model="selectedNode" @onCancel="onCancelApi" @onSave="onSaveApi">
            <div class="text-xs-right" slot="header">
              <v-btn fab flat small @click="onCancelApi">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </api-manage>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showEditRandom" persistent max-width="600">
      <v-card v-if="selectedNode && showEditRandom">
        <v-card-text :key="selectedNode.id">
          <random-manage
            v-model="selectedNode"
            @onCancel="onCancelRandom"
            @onSave="onSaveRandom"
          ></random-manage>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showEditCondition" persistent max-width="1000">
      <v-card v-if="selectedNode && showEditCondition">
        <v-card-text :key="selectedNode.id">
          <condition-manage
            v-model="selectedNode"
            @onSave="onSaveCondition"
            @onCancel="onCancelCondition"
          >
            <div class="text-xs-right" slot="header">
              <v-btn fab flat small @click="onCancelCondition">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </condition-manage>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showConnection" persistent max-width="600">
      <v-card v-if="selectedNode && showConnection">
        <v-card-text :key="selectedNode.id" class="pa-2">
          <v-card
            v-for="(connection, index) in selectedNode.connected_intents"
            :key="'connection_' + index"
          >
            <v-card-text>{{ connection }}</v-card-text>
          </v-card>
          <div class="text-xs-center">
            <v-btn outline color="grey" @click="showConnection = false">{{ $t('Close') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showEditText" persistent max-width="600">
      <v-card v-if="selectedNode && showEditText">
        <v-card-text :key="selectedNode.id">
          <question-manage v-model="selectedQuestionText">
            <v-btn
              outline
              color="primary"
              slot="delete-connection"
              v-if="selectedNode.isConnected"
              @click="onDeleteConnection"
            >
              <v-icon class="mr-2">delete</v-icon>Delete
            </v-btn>
            <div class="text-xs-right" slot="header">
              <v-btn fab flat small @click="onCancelEditText">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </question-manage>
        </v-card-text>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="onCancelEditText">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="onSaveEditText">{{ $t('Save') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showEditDefault" persistent max-width="600">
      <v-card v-if="selectedNode && showEditDefault">
        <v-card-text :key="selectedNode.id">
          <default-manage
            v-model="selectedNode"
            @onSave="onSaveEditDefault"
            @onCancel="onCancelEditDefault"
            @onDeleteConnection="onDeleteConnection"
          ></default-manage>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showEditFlow" persistent max-width="1000">
      <v-card v-if="selectedNode && showEditFlow">
        <v-card-text>
          <flow-manage
            v-model="selectedNode"
            @onSave="onSaveEditFlow"
            @onCancel="onCancelEditFlow"
          ></flow-manage>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showEditVariable" persistent max-width="1000">
      <v-card v-if="selectedNode && showEditVariable">
        <v-card-text>
          <variable-manage
            v-model="selectedNode"
            @onSave="onSaveEditVariable"
            @onCancel="onCancelEditVariable"
          ></variable-manage>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="showEditPersistent" persistent max-width="400">
      <v-card v-if="showEditPersistent">
        <v-card-text>
          <ul style="padding: 0;margin: auto; max-width: 300px">
            <li
              style="list-style-type: none; padding: 10px 0px;color: black;text-align: center;border-top-left-radius: 10px;border-top-right-radius: 10px;border: 1px solid #dddfe2;border-bottom: 0"
            >
              <div class="strong">{{ $t('Main menu') }}</div>
            </li>
            <template v-if="tmpPersistentMenu.length > 0">
              <li
                v-for="(menu, index) in tmpPersistentMenu"
                :key="'menu_' + index + '_' + menu.title"
                style="position:relative;list-style-type: none;border: 1px solid #dddfe2; border-top: 1px solid #dddfe2;"
                :class="{
                  'persistent-menu-bottom': index == 20 - 1
                }"
              >
                <add-button-persistent-menu
                  v-model="tmpPersistentMenu[index]"
                  @onDelete="deleteMenu(index)"
                  :hasNested="true"
                  :onEdit="true"
                >
                  <template slot="append">
                    <v-list-tile
                      :disabled="index <= 0"
                      @click="onMoveButton(index, 'up', tmpPersistentMenu)"
                    >
                      <v-list-tile-title
                        :style="index <= 0 ? `color: lightgrey` : ''"
                        class="primary-color"
                        >{{ $t('Move up') }}</v-list-tile-title
                      >
                    </v-list-tile>
                    <v-list-tile
                      :disabled="index >= tmpPersistentMenu.length - 1"
                      @click="onMoveButton(index, 'down', tmpPersistentMenu)"
                    >
                      <v-list-tile-title
                        :style="index >= tmpPersistentMenu.length - 1 ? `color: lightgrey` : ''"
                        class="primary-color"
                        >{{ $t('Move down') }}</v-list-tile-title
                      >
                    </v-list-tile>
                  </template>
                </add-button-persistent-menu>

                <!-- <a href="javascript:void(0);" style="width: 22px;margin-top: 8px;display: inline-block" v-if="menu.type == 'postback' && editing" @click="createSubMenu(index)"><span class="glyphicon glyphicon-plus"></span></a> -->
                <div class="clearfix"></div>
              </li>
            </template>
            <template v-else> </template>

            <li
              v-if="tmpPersistentMenu.length < 20"
              style="list-style-type: none; border: 1px dashed #dddfe2; border-top: 0; padding: 10px 0px;overflow:auto;text-align: center;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;"
            >
              <a href="javascript:void(0);" @click="addMenu" class="primary-color">
                <span class="fa fa-plus"></span>
                {{ $t('Add menu') }}
              </a>
            </li>
          </ul>

          <div class="text-xs-center">
            <v-btn outline color="grey" @click="onCancelPersistent">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" depressed @click="onSavePersistent">{{ $t('Save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div v-if="!loading">
      <div
        v-if="nodes.length == 0"
        style="width: 100%;padding-top: 60px; padding-left: 90px; padding-right: 10px; overflow: auto"
        :style="{ height: maxHeight + 'px' }"
      >
        <v-card>
          <div>
            <intent-manage v-model="newNode" @onSave="onSaveStartNode">
              <div slot="footer" class="text-xs-center" slot-scope="scope">
                <v-btn color="primary" depressed @click="scope.onSave">{{ $t('Save') }}</v-btn>
              </div>
            </intent-manage>
          </div>
        </v-card>
      </div>
      <template v-else>
        <v-stage
          ref="stage"
          :config="{
            width: configKonva.width,
            height: configKonva.height,
            x: configKonva.x,
            y: configKonva.y,
            draggable: !onHoldShift,
            scale: configKonva.scale
          }"
          @wheel="onZoom"
          @dragstart="onStageDragStart"
          @dragend="onStageDragEnd"
          @mousedown="onStageMouseDown"
          @mouseup="onStageMouseUp"
          @mousemove="onStageMouseMove"
          @click="onStageClick"
        >
          <v-layer ref="layer">
            <v-rect
              v-if="selectedArea"
              ref="selectionrect"
              :config="{
                x: selectedArea.x,
                y: selectedArea.y,
                height: selectedArea.height,
                width: selectedArea.width,
                visible: selectedArea.visible,
                fill: '#9eff2040',
                stroke: '#9eff20'
              }"
            ></v-rect>
            <template v-if="tmpPersistentMenu.length > 0">
              <template v-for="line in persistentConnections">
                <v-line
                  :config="{
                    stroke: '#9e9e9e',
                    strokeWidth: 3,
                    bezier: line.isBezier,
                    points: line.points,
                    tension: line.tension ? line.tension : 0
                  }"
                  :key="line.id"
                />
              </template>
            </template>

            <template v-for="(node, index) in nodes">
              <v-group :ref="`node_group_${node.id}`" :key="`node_group_${node.id}`">
                <v-text
                  v-if="showDebug"
                  :config="{
                    text: node.id + ` (${node.x},${node.y})`,
                    x: node.x,
                    y: node.y - 20
                  }"
                ></v-text>

                <v-rect
                  v-if="node.isSearch"
                  :config="{
                    x: checkNaN(node.x),
                    y: checkNaN(node.y),
                    width: 300,
                    height: checkNaN(60 + (node.height ? node.height : nodeHeight)),
                    fill: 'transparent',
                    strokeWidth: 8,
                    stroke: 'red',
                    opacity: 1,
                    cornerRadius: 10
                  }"
                  :key="'node_bg_search_' + index"
                ></v-rect>

                <v-rect
                  v-if="node"
                  :config="{
                    x: checkNaN(node.x),
                    y: checkNaN(node.y),
                    width: 300,
                    height: checkNaN(60 + (node.height ? node.height : nodeHeight)),
                    fill: currentNodeMouserOver.includes(node.id) ? '#d9ffd2' : 'white',
                    strokeWidth: 1,
                    stroke: '#eee',
                    opacity: 0.9,
                    cornerRadius: 10
                  }"
                  :key="'node_bg_' + index"
                ></v-rect>
                <v-rect
                  :config="{
                    x: checkNaN(node.x),
                    y: checkNaN(node.y),
                    cornerRadius: [10, 10, 0, 0],
                    width: 300,
                    height: 50,
                    fill: node.fillHeader ? node.fillHeader : 'white'
                  }"
                  :key="'node_start_node_' + index"
                ></v-rect>
                <v-text
                  :ref="`node_title_${index}`"
                  :config="{
                    text: node.intentname,
                    width: 300,
                    height: 50,
                    fill: 'black',
                    fontSize: 18,
                    align: 'center',
                    x: checkNaN(node.x),
                    y: checkNaN(node.y) + 15
                  }"
                  :key="'node_title_' + index"
                ></v-text>

                <template v-if="node.type == 'start_node'">
                  <template v-if="!loadingPersistentMenu && persistentMenu">
                    <v-rect
                      :config="{
                        x: checkNaN(node.x) - 830,
                        y: checkNaN(
                          node.y + 42 + (node.height ? node.height / 2 : nodeHeight / 2) - 12
                        ),
                        width: 300,
                        height: buttonHeight * (persistentMenu.length || 1),
                        fill: 'white',
                        strokeWidth: 1,
                        stroke: '#eee',
                        opacity: 0.9,
                        cornerRadius: 10
                      }"
                      :key="'node_persistent_bg'"
                    ></v-rect>

                    <template v-for="(actions, pindex) in persistentMenu">
                      <v-rect
                        :config="{
                          width: 300,
                          height: buttonHeight ? buttonHeight : 50,
                          cornerRadius:
                            persistentMenu.length == 1
                              ? [10, 10, 10, 10]
                              : pindex == 0
                              ? [10, 10, 0, 0]
                              : persistentMenu.length - 1 == pindex
                              ? [0, 0, 10, 10]
                              : [0, 0, 0, 0],
                          strokeWidth: 2,
                          stroke: '#eee',
                          y:
                            node.y +
                            42 +
                            (node.height ? node.height / 2 : nodeHeight / 2) -
                            12 +
                            buttonHeight * pindex,
                          x: checkNaN(node.x) - 830
                        }"
                        :key="`node_persistent_title_bg_${pindex}`"
                      ></v-rect>
                      <v-text
                        :config="{
                          text: actions.title,
                          x: checkNaN(node.x) - 830,
                          y: checkNaN(
                            node.y +
                              42 +
                              (node.height ? node.height / 2 : nodeHeight / 2) -
                              12 +
                              buttonHeight * pindex
                          ),
                          width: 300,
                          height: buttonHeight,
                          fontSize: 16,
                          align: 'center',
                          padding: 10,
                          offset: {
                            y: -10
                          }
                        }"
                        :key="'node_persistent_title_' + pindex"
                      ></v-text>

                      <v-circle
                        v-if="actions.type == 'postback'"
                        :config="{
                          radius: 6,
                          y:
                            node.y +
                            42 +
                            (node.height ? node.height / 2 : nodeHeight / 2) -
                            12 +
                            buttonHeight * pindex +
                            buttonHeight / 2,
                          x: checkNaN(node.x) - 530,
                          fill: '#61a9de',
                          stroke: '#61a9de',
                          strokeWidth: 1,
                          type: 'point'
                        }"
                        :ref="`node_persistent_point_${node.id}_${pindex}`"
                        :key="`node_persistent_point_${node.id}_${pindex}`"
                      ></v-circle>
                    </template>

                    <template v-if="persistentMenu.length == 0">
                      <v-text
                        :config="{
                          text: '+ Add Persistent Menu',
                          x: checkNaN(node.x) - 830,
                          y: checkNaN(
                            node.y + 42 + (node.height ? node.height / 2 : nodeHeight / 2) - 12
                          ),
                          width: 300,
                          height: buttonHeight,
                          fontSize: 16,
                          align: 'center',
                          padding: 10,
                          offset: {
                            y: -10
                          }
                        }"
                      ></v-text>
                    </template>

                    <v-rect
                      :config="{
                        x: checkNaN(node.x) - 830,
                        y: checkNaN(
                          node.y + 42 + (node.height ? node.height / 2 : nodeHeight / 2) - 12
                        ),
                        width: 300,
                        height: buttonHeight * (persistentMenu.length || 1),
                        cornerRadius: 10
                      }"
                      @click="editPersistentMenu"
                      :key="'node_persistent_actions'"
                    ></v-rect>
                  </template>

                  <v-rect
                    :config="{
                      x: checkNaN(node.x) - 430,
                      y: checkNaN(
                        node.y + 42 + (node.height ? node.height / 2 : nodeHeight / 2) - 12
                      ),
                      width: 300,
                      height: 25 + (node.questionHeight ? node.questionHeight : 0),
                      fill: 'white',
                      strokeWidth: 1,
                      stroke: '#eee',
                      opacity: 0.9,
                      cornerRadius: 10
                    }"
                    :key="'node_start_bg_' + index"
                  ></v-rect>
                  <v-text
                    :config="{
                      text: 'User input to flow',
                      x: checkNaN(node.x) - 430,
                      y: checkNaN(
                        node.y + 42 + (node.height ? node.height / 2 : nodeHeight / 2) - 12
                      ),
                      fill: '#61a9de',
                      width: 300,
                      fontSize: 16,
                      align: 'center',
                      padding: 10
                    }"
                    :key="'node_start_title_' + index"
                  ></v-text>

                  <v-text
                    :config="{
                      text: node.question,
                      x: checkNaN(node.x) - 430,
                      y: checkNaN(
                        node.y + 42 + 25 + (node.height ? node.height / 2 : nodeHeight / 2) - 12
                      ),
                      fill: 'black',
                      width: 300,
                      fontSize: 16,
                      align: 'center',
                      padding: 10
                    }"
                    :ref="'node_start_' + node.id"
                    :key="'node_start_' + index"
                  ></v-text>

                  <v-regular-polygon
                    :config="{
                      sides: 3,
                      radius: 10,
                      y: checkNaN(
                        node.y +
                          42 +
                          (node.height ? node.height / 2 : nodeHeight / 2) +
                          (node.questionHeight ? node.questionHeight / 2 : 0)
                      ),
                      x: checkNaN(node.x) - 430,
                      fill: '#61a9de',
                      rotation: 90
                    }"
                    :ref="`node_start_point_in_${node.id}`"
                    :key="`node_start_point_in_${node.id}`"
                  ></v-regular-polygon>

                  <v-circle
                    :config="{
                      radius: 6,
                      y: checkNaN(
                        node.y +
                          42 +
                          (node.height ? node.height / 2 : nodeHeight / 2) +
                          (node.questionHeight ? node.questionHeight / 2 : 0)
                      ),
                      x: checkNaN(node.x) - 130,
                      fill: '#61a9de',
                      stroke: '#61a9de',
                      strokeWidth: 1,
                      type: 'point'
                    }"
                    :ref="`node_start_point_${node.id}`"
                    :key="`node_start_point_${node.id}`"
                  ></v-circle>
                </template>

                <v-line
                  :ref="`node_line_${index}`"
                  :config="{
                    x: checkNaN(node.x),
                    y: checkNaN(node.y),
                    strokeWidth: 2,
                    points: [0, 50, 300, 50],
                    stroke: '#eee'
                  }"
                  :key="'node_line_' + index"
                ></v-line>
                <template v-if="node.type == 'api'">
                  <template
                    v-if="node.answer && node.answer.length > 0 && node.answer[0].length > 0"
                  >
                    <v-rect
                      :config="{
                        width: 60,
                        height: 30,
                        cornerRadius: 50,
                        fill: '#61a9de',
                        y: checkNaN(node.y) + 60 + 5,
                        x: checkNaN(node.x) + 15
                      }"
                      :key="`node_message_method_${node.id}`"
                      :ref="`node_message_method_${node.id}`"
                    ></v-rect>
                    <v-text
                      :config="{
                        width: 60,
                        align: 'center',
                        text: `${node.answer[0][0].api_method}`,
                        padding: 10,
                        y: checkNaN(node.y) + 60 + 5,
                        x: checkNaN(node.x) + 15,
                        fill: 'white'
                      }"
                      :key="`node_api_method_${node.id}`"
                    ></v-text>
                    <v-text
                      :config="{
                        width: 210,
                        text: `${node.answer[0][0].api_name}`,
                        padding: 10,
                        y: checkNaN(node.y) + 60 + 5,
                        x: checkNaN(node.x) + 15 + 60,
                        fill: '#61a9de'
                      }"
                      :key="`node_api_name_${node.id}`"
                    ></v-text>
                  </template>
                  <template v-else>
                    <v-rect
                      :config="{
                        width: 270,
                        height: 30,
                        cornerRadius: 10,
                        fill: '#eee',
                        strokeWidth: 2,
                        stroke: '#eee',
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15
                      }"
                      :key="`node_message_empty_${node.id}`"
                      :ref="`node_message_empty_${node.id}`"
                    ></v-rect>
                    <v-text
                      :config="{
                        width: 270,
                        text: 'Click to edit api',
                        padding: 10,
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15,
                        align: 'center'
                      }"
                      :key="`node_empty_${node.id}`"
                    ></v-text>
                  </template>
                </template>
                <template v-else-if="node.type == 'random'">
                  <template
                    v-if="node.answer && node.answer.length > 0 && node.answer[0].length > 0"
                  >
                    <template v-for="(to, tindex) in node.answer[0][0].to">
                      <v-rect
                        :config="{
                          width: 270,
                          height: 30,
                          cornerRadius:
                            node.answer[0][0].to.length != 1
                              ? tindex == node.answer[0][0].to.length - 1
                                ? [0, 0, 10, 10]
                                : tindex == 0
                                ? [10, 10, 0, 0]
                                : 0
                              : 10,
                          fill: 'white',
                          strokeWidth: 1,
                          stroke: '#61a9de',
                          y: checkNaN(node.y) + 60 + tindex * 30,
                          x: checkNaN(node.x) + 15
                        }"
                        :key="`node_message_random_${node.id}_${tindex}`"
                        :ref="`node_message_random_${node.id}_${tindex}`"
                      ></v-rect>
                      <v-text
                        :config="{
                          width: 270,
                          text: `Random ${tindex + 1}`,
                          padding: 10,
                          y: checkNaN(node.y) + 60 + tindex * 30,
                          x: checkNaN(node.x) + 15,
                          fill: '#61a9de'
                        }"
                        :key="`node_random_${node.id}_${tindex}`"
                      ></v-text>
                    </template>
                  </template>
                  <template v-else>
                    <v-rect
                      :config="{
                        width: 270,
                        height: 30,
                        cornerRadius: 10,
                        fill: '#eee',
                        strokeWidth: 2,
                        stroke: '#eee',
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15
                      }"
                      :key="`node_message_empty_${node.id}`"
                      :ref="`node_message_empty_${node.id}`"
                    ></v-rect>
                    <v-text
                      :config="{
                        width: 270,
                        text: 'Click to edit random',
                        padding: 10,
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15,
                        align: 'center'
                      }"
                      :key="`node_empty_${node.id}`"
                    ></v-text>
                  </template>
                </template>

                <template v-else-if="node.type == 'flow'">
                  <template
                    v-if="
                      node.connected_intents &&
                        node.connected_intents.length > 0 &&
                        node.answer &&
                        node.answer.length > 0 &&
                        node.answer[0].length > 0
                    "
                  >
                    <v-text
                      :config="{
                        width: 100,
                        text: 'Flow name',
                        fontStyle: 'bold',
                        padding: 10,
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15,
                        align: 'left'
                      }"
                      :key="`node_flow_title_${node.id}`"
                    ></v-text>

                    <v-text
                      :config="{
                        width: 170,
                        text: node.answer[0][0].flowname,
                        padding: 10,
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15 + 100,
                        align: 'left'
                      }"
                      :key="`node_flow_${node.id}`"
                      :ref="`node_flow_${node.id}`"
                    ></v-text>

                    <v-text
                      :config="{
                        width: 100,
                        text: 'Intent name',
                        fontStyle: 'bold',
                        padding: 10,
                        y:
                          checkNaN(node.y) +
                          60 +
                          (node.answer[0][0].flownameHeight &&
                          !isNaN(node.answer[0][0].flownameHeight)
                            ? node.answer[0][0].flownameHeight
                            : 0),
                        x: checkNaN(node.x) + 15,
                        align: 'left'
                      }"
                      :key="`node_intent_title_${node.id}`"
                    ></v-text>

                    <v-text
                      :config="{
                        width: 170,
                        text: node.answer[0][0].intentname,
                        padding: 10,
                        y:
                          checkNaN(node.y) +
                          60 +
                          (node.answer[0][0].flownameHeight &&
                          !isNaN(node.answer[0][0].flownameHeight)
                            ? node.answer[0][0].flownameHeight
                            : 0),
                        x: checkNaN(node.x) + 15 + 100,
                        align: 'left'
                      }"
                      :key="`node_intent_${node.id}`"
                      :ref="`node_intent_${node.id}`"
                    ></v-text>
                  </template>
                  <template v-else>
                    <v-rect
                      :config="{
                        width: 270,
                        height: 30,
                        cornerRadius: 10,
                        fill: '#eee',
                        strokeWidth: 2,
                        stroke: '#eee',
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15
                      }"
                      :key="`node_message_empty_${node.id}`"
                      :ref="`node_message_empty_${node.id}`"
                    ></v-rect>
                    <v-text
                      :config="{
                        width: 270,
                        text: 'Click to edit flow',
                        padding: 10,
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15,
                        align: 'center'
                      }"
                      :key="`node_empty_${node.id}`"
                    ></v-text>
                  </template>
                </template>
                <template v-else-if="node.type == 'savevariables'">
                  <template
                    v-if="node.answer && node.answer.length > 0 && node.answer[0].length > 0"
                  >
                    <template v-for="(variable, vindex) in node.answer[0][0].variables">
                      <v-text
                        :key="`node_variable_${node.id}_${vindex}`"
                        :ref="`node_variable_${node.id}_${vindex}`"
                        :config="{
                          width: 270,
                          text: variable.text,
                          padding: 10,
                          y: checkNaN(node.y) + 60 + checkNaN(variable.height),
                          x: checkNaN(node.x) + 15
                        }"
                      ></v-text>
                      <v-line
                        :config="{
                          x: checkNaN(node.x),
                          y: checkNaN(node.y) + 60 + variable.height,
                          strokeWidth: 1,
                          points: [0, 0, 300, 0],
                          stroke: '#eee'
                        }"
                        v-if="vindex != 0"
                        :key="`node_variable_line_${node.id}_${vindex}`"
                      ></v-line>
                    </template>
                  </template>
                  <template v-else>
                    <v-rect
                      :config="{
                        width: 270,
                        height: 30,
                        cornerRadius: 10,
                        fill: '#eee',
                        strokeWidth: 2,
                        stroke: '#eee',
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15
                      }"
                      :key="`node_message_empty_${node.id}`"
                      :ref="`node_message_empty_${node.id}`"
                    ></v-rect>
                    <v-text
                      :config="{
                        width: 270,
                        text: 'Click to edit variable',
                        padding: 10,
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15,
                        align: 'center'
                      }"
                      :key="`node_empty_${node.id}`"
                    ></v-text>
                  </template>
                </template>
                <template v-else>
                  <template
                    v-if="node.answer && node.answer.length > 0 && node.answer[0].length > 0"
                  >
                    <template v-for="(answer, aindex) in node.answer">
                      <template v-for="(message, mindex) in answer">
                        <template v-if="message.type == 'text'">
                          <v-rect
                            :config="{
                              width: 270,
                              height: message.messageHeight ? message.messageHeight : 50,
                              cornerRadius: 10,
                              fill: '#eee',
                              strokeWidth: 2,
                              stroke: '#eee',
                              y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                              x: checkNaN(node.x) + 15
                            }"
                            :key="`node_message_${node.id}_${aindex}_${mindex}`"
                          ></v-rect>
                          <v-text
                            :config="{
                              width: 270,
                              text: message.text,
                              padding: 10,
                              y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                              x: checkNaN(node.x) + 15,
                              lineHeight: 1.5
                            }"
                            :ref="`node_answer_text_${node.id}_${aindex}_${mindex}`"
                            :key="`node_answer_text_${node.id}_${aindex}_${mindex}`"
                          ></v-text>
                        </template>
                        <template v-else-if="message.type == 'button'">
                          <v-rect
                            :config="{
                              width: 270,
                              height: message.messageHeight ? message.messageHeight : 50,
                              cornerRadius:
                                message.buttons.length > 0 ? [10, 10, 0, 0] : [10, 10, 10, 10],
                              fill: '#eee',
                              strokeWidth: 2,
                              stroke: '#eee',
                              y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                              x: checkNaN(node.x) + 15
                            }"
                            :key="`node_message_${node.id}_${aindex}_${mindex}`"
                          ></v-rect>
                          <v-text
                            :config="{
                              width: 270,
                              text: message.text,
                              padding: 10,
                              y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                              x: checkNaN(node.x) + 15,
                              lineHeight: 1.5
                            }"
                            :ref="`node_answer_text_${node.id}_${aindex}_${mindex}`"
                            :key="`node_answer_text_${node.id}_${aindex}_${mindex}`"
                          ></v-text>
                          <template v-for="(button, bindex) in message.buttons">
                            <v-rect
                              :config="{
                                width: 270,
                                height: buttonHeight,
                                cornerRadius:
                                  bindex == message.buttons.length - 1
                                    ? [0, 0, 10, 10]
                                    : [0, 0, 0, 0],
                                fill: 'white',
                                strokeWidth: 2,
                                stroke: '#eee',
                                y:
                                  (message.messageHeight ? message.messageHeight : 50) +
                                  (message.y ? message.y : 0) +
                                  checkNaN(node.y) +
                                  60 +
                                  bindex * buttonHeight,
                                x: checkNaN(node.x) + 15
                              }"
                              :key="`node_message_button_${node.id}_${mindex}_${bindex}`"
                            ></v-rect>
                            <v-text
                              :config="{
                                width: 270,
                                height: buttonHeight,
                                text: button.title,
                                y:
                                  (message.messageHeight ? message.messageHeight : 50) +
                                  (message.y ? message.y : 0) +
                                  checkNaN(node.y) +
                                  60 +
                                  bindex * buttonHeight,
                                x: checkNaN(node.x) + 15,
                                align: 'center',
                                fill: '#61a9de',
                                fontSize: 17,
                                offset: {
                                  y: -10
                                }
                              }"
                              :ref="`node_message_button_text_${node.id}_${aindex}_${mindex}`"
                              :key="
                                `node_message_button_text_${node.id}_${aindex}_${mindex}_${bindex}`
                              "
                            ></v-text>
                          </template>
                        </template>
                        <template v-else-if="message.type == 'image'">
                          <template
                            v-if="
                              message.loaded == true &&
                                message.image_url &&
                                message.image &&
                                isImage(message.image)
                            "
                          >
                            <v-rect
                              :config="{
                                width: 270,
                                height: imageHeight,
                                cornerRadius: 10,
                                fillPatternImage: message.image,
                                fillPatternRepeat: 'no-repeat',
                                fillPatternScale: {
                                  x: 270 / message.image.width,
                                  y: 270 / message.image.width
                                },
                                strokeWidth: 2,
                                stroke: '#eee',
                                y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                                x: checkNaN(node.x) + 15
                              }"
                              :key="`node_image_${node.id}_${aindex}_${mindex}`"
                            ></v-rect>
                          </template>
                          <template v-else>
                            <v-rect
                              :config="{
                                width: 270,
                                height: imageHeight,
                                cornerRadius: 10,
                                fill: '#eee',
                                strokeWidth: 2,
                                stroke: '#eee',
                                y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                                x: checkNaN(node.x) + 15
                              }"
                              :key="`node_image_${node.id}_${aindex}_${mindex}`"
                            ></v-rect>
                          </template>
                        </template>
                        <template v-else-if="message.type == 'video' || message.type == 'audio'">
                          <v-rect
                            :config="{
                              width: 270,
                              height: videoAndAudioHeight,
                              cornerRadius: 10,
                              fill: '#eee',
                              strokeWidth: 2,
                              stroke: '#eee',
                              y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                              x: checkNaN(node.x) + 15
                            }"
                            :key="`node_${message.type}_${node.id}_${aindex}_${mindex}`"
                          ></v-rect>
                          <v-text
                            :config="{
                              width: 270,
                              height: 20,
                              text: `${message.type}`,
                              y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                              x: checkNaN(node.x) + 15,
                              align: 'center',
                              fill: '#61a9de',
                              fontSize: 12,
                              offset: {
                                y: -10
                              }
                            }"
                            :ref="`node_${message.type}_text_${node.id}_${aindex}_${mindex}`"
                            :key="`node_${message.type}_text_${node.id}_${aindex}_${mindex}`"
                          />
                          <v-text
                            :config="{
                              width: 270,
                              height: 20,
                              text: handleGetFileNameFromUrl(message.source),
                              y: checkNaN(node.y) + 60 + (message.y ? message.y : 0) + 20,
                              x: checkNaN(node.x) + 15,
                              align: 'center',
                              fill: 'black',
                              fontSize: 14,
                              offset: {
                                y: -10
                              }
                            }"
                            :ref="`node_${message.type}_source_${node.id}_${aindex}_${mindex}`"
                            :key="`node_${message.type}_source_${node.id}_${aindex}_${mindex}`"
                          >
                          </v-text>
                        </template>
                        <template v-else-if="message.type == 'generic'">
                          <template v-for="(generic, gindex) in message.data">
                            <v-rect
                              :config="{
                                width: 270,
                                height: generic.genericHeight ? generic.genericHeight : 141,
                                cornerRadius: 10,
                                fill: '#eee',
                                strokeWidth: 2,
                                stroke: '#eee',
                                y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                                x: checkNaN(node.x) + 15 + gindex * 295
                              }"
                              :key="`node_message_${node.id}_${aindex}_${mindex}_${gindex}`"
                            ></v-rect>

                            <template
                              v-if="
                                generic.loaded == true &&
                                  generic.image_url &&
                                  generic.image &&
                                  isImage(generic.image)
                              "
                            >
                              <v-rect
                                :config="{
                                  width: 270,
                                  height: imageHeight,
                                  cornerRadius: [10, 10, 0, 0],
                                  fillPatternImage: generic.image,
                                  fillPatternRepeat: 'no-repeat',
                                  fillPatternScale: {
                                    x: 270 / generic.image.width,
                                    y: 270 / generic.image.width
                                  },
                                  strokeWidth: 2,
                                  stroke: '#eee',
                                  y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                                  x: checkNaN(node.x) + 15 + gindex * 295
                                }"
                                :key="`node_image_${node.id}_${aindex}_${mindex}_${gindex}`"
                              ></v-rect>
                            </template>
                            <template v-else>
                              <v-rect
                                :config="{
                                  width: 270,
                                  height: imageHeight,
                                  cornerRadius: [10, 10, 0, 0],
                                  fill: '#eee',
                                  strokeWidth: 2,
                                  stroke: '#eee',
                                  y: checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                                  x: checkNaN(node.x) + 15 + gindex * 295
                                }"
                                :key="`node_image_${node.id}_${aindex}_${mindex}_${gindex}`"
                              ></v-rect>
                            </template>

                            <v-rect
                              :config="{
                                width: 270,
                                height: generic.genericMessageHeight
                                  ? generic.genericMessageHeight
                                  : 50,
                                cornerRadius: 0,
                                fill: 'white',
                                strokeWidth: 2,
                                stroke: '#eee',
                                y:
                                  checkNaN(node.y) + 60 + (message.y ? message.y : 0) + imageHeight,
                                x: checkNaN(node.x) + 15 + gindex * 295
                              }"
                              :key="`node_generic_${node.id}_${aindex}_${mindex}_${gindex}`"
                            ></v-rect>

                            <v-text
                              :config="{
                                width: 270,
                                text: generic.title,
                                padding: 10,
                                y:
                                  checkNaN(node.y) + 60 + (message.y ? message.y : 0) + imageHeight,
                                x: checkNaN(node.x) + 15 + gindex * 295,
                                lineHeight: 1.2
                              }"
                              :key="`node_generic_title_${node.id}_${aindex}_${mindex}_${gindex}`"
                              :ref="`node_generic_title_${node.id}_${aindex}_${mindex}_${gindex}`"
                            ></v-text>

                            <v-text
                              :config="{
                                width: 270,
                                text: generic.subtitle,
                                padding: 10,
                                y:
                                  checkNaN(node.y) +
                                  60 +
                                  (message.y ? message.y : 0) +
                                  imageHeight +
                                  generic.titleHeight,
                                x: checkNaN(node.x) + 15 + gindex * 295,
                                lineHeight: 1.2
                              }"
                              :key="
                                `node_generic_subtitle_${node.id}_${aindex}_${mindex}_${gindex}`
                              "
                              :ref="
                                `node_generic_subtitle_${node.id}_${aindex}_${mindex}_${gindex}`
                              "
                            ></v-text>

                            <template v-for="(button, bindex) in generic.buttons">
                              <v-rect
                                :config="{
                                  width: 270,
                                  height: buttonHeight,
                                  cornerRadius:
                                    bindex == generic.buttons.length - 1
                                      ? [0, 0, 10, 10]
                                      : [0, 0, 0, 0],
                                  fill: 'white',
                                  strokeWidth: 2,
                                  stroke: '#eee',
                                  y:
                                    (message.y ? message.y : 0) +
                                    checkNaN(node.y) +
                                    60 +
                                    bindex * buttonHeight +
                                    imageHeight +
                                    (generic.genericMessageHeight
                                      ? generic.genericMessageHeight
                                      : 0),
                                  x: checkNaN(node.x) + 15 + gindex * 295
                                }"
                                :key="
                                  `node_message_generic_button_${node.id}_${mindex}_${gindex}_${bindex}`
                                "
                              ></v-rect>
                              <v-text
                                :config="{
                                  width: 270,
                                  height: buttonHeight,
                                  text: button.title,
                                  y:
                                    (message.y ? message.y : 0) +
                                    checkNaN(node.y) +
                                    60 +
                                    bindex * buttonHeight +
                                    imageHeight +
                                    (generic.genericMessageHeight
                                      ? generic.genericMessageHeight
                                      : 0),
                                  x: checkNaN(node.x) + 15 + gindex * 295,
                                  align: 'center',
                                  fill: '#61a9de',
                                  fontSize: 17,
                                  offset: {
                                    y: -10
                                  }
                                }"
                                :ref="
                                  `node_message_generic_button_text_${node.id}_${aindex}_${mindex}`
                                "
                                :key="
                                  `node_message_generic_button_text_${node.id}_${aindex}_${mindex}_${gindex}_${bindex}`
                                "
                              ></v-text>
                            </template>
                          </template>
                        </template>
                        <template v-else-if="message.type == 'condition'">
                          <template v-for="(condition, cindex) in message.condition">
                            <v-rect
                              :config="{
                                width: 270,
                                height: condition.messageHeight ? condition.messageHeight : 0,
                                cornerRadius:
                                  message.condition.length == 1
                                    ? 10
                                    : cindex == message.condition.length - 1
                                    ? [0, 0, 10, 10]
                                    : cindex == 0
                                    ? [10, 10, 0, 0]
                                    : 0,
                                fill: 'white',
                                strokeWidth: 1,
                                stroke: '#61a9de',
                                y:
                                  checkNaN(node.y) +
                                  60 +
                                  (condition.y ? condition.y : 0) +
                                  (message.y ? message.y : 0),
                                x: checkNaN(node.x) + 15
                              }"
                              :key="`node_message_condition_${node.id}_${cindex}`"
                              :ref="`node_message_condition_${node.id}_${cindex}`"
                            ></v-rect>
                            <v-text
                              :config="{
                                width: 270,
                                text: condition.caseText,
                                padding: 10,
                                y:
                                  checkNaN(node.y) +
                                  60 +
                                  (condition.y ? condition.y : 0) +
                                  (message.y ? message.y : 0),
                                x: checkNaN(node.x) + 15,
                                lineHeight: 1.5
                              }"
                              :ref="
                                `node_answer_condition_${node.id}_${aindex}_${mindex}_${cindex}`
                              "
                              :key="
                                `node_answer_condition_${node.id}_${aindex}_${mindex}_${cindex}`
                              "
                            ></v-text>
                          </template>
                        </template>
                      </template>
                    </template>
                  </template>

                  <template v-else>
                    <v-rect
                      :config="{
                        width: 270,
                        height: 30,
                        cornerRadius: 10,
                        fill: '#eee',
                        strokeWidth: 2,
                        stroke: '#eee',
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15
                      }"
                      :key="`node_message_empty_${node.id}`"
                      :ref="`node_message_empty_${node.id}`"
                    ></v-rect>
                    <v-text
                      :config="{
                        width: 270,
                        text: 'Click to edit conversation',
                        padding: 10,
                        y: checkNaN(node.y) + 60,
                        x: checkNaN(node.x) + 15,
                        align: 'center'
                      }"
                      :key="`node_empty_${node.id}`"
                    ></v-text>
                  </template>
                </template>

                <template v-if="['start_node', 'node'].includes(node.type)">
                  <template v-if="node.choices && node.choices.list">
                    <template v-for="(choice, cindex) in node.choices.list">
                      <v-rect
                        :config="{
                          width: choice.messageWidth,
                          height: choice.messageHeight ? choice.messageHeight : 50,
                          cornerRadius: 50,
                          fill: 'white',
                          strokeWidth: 2,
                          stroke: '#eee',
                          y: checkNaN(node.y) + 60 + (choice.y ? choice.y : 0),
                          x: checkNaN(node.x) + 15 - choice.messageWidth,
                          offset: {
                            x: -270,
                            y: 0
                          }
                        }"
                        :key="`node_choice_${node.id}_${cindex}`"
                      ></v-rect>
                      <v-text
                        :config="{
                          text: choice.text,
                          padding: 10,
                          y: checkNaN(node.y) + 60 + (choice.y ? choice.y : 0),
                          x: checkNaN(node.x) + 15 - choice.messageWidth,
                          lineHeight: 1.5,
                          align: 'right',
                          offset: {
                            x: -270,
                            y: 0
                          }
                        }"
                        :ref="`node_choice_text_${node.id}_${cindex}`"
                        :key="`node_choice_text_${node.id}_${cindex}`"
                      ></v-text>
                    </template>
                  </template>

                  <v-rect
                    :config="{
                      width: 270,
                      height: node.userinput.messageHeight ? node.userinput.messageHeight : 50,
                      cornerRadius: 10,
                      fill: 'white',
                      strokeWidth: 1,
                      stroke: '#61a9de',
                      y: checkNaN(node.y) + 60 + (node.userinput.y ? node.userinput.y : 0),
                      x: checkNaN(node.x) + 15
                    }"
                    :key="`node_question_${node.id}`"
                  ></v-rect>
                  <v-text
                    :config="{
                      width: 270,
                      text: 'User input',
                      padding: 10,
                      y: checkNaN(node.y) + 60 + (node.userinput.y ? node.userinput.y : 0),
                      x: checkNaN(node.x) + 15,
                      fill: '#61a9de'
                    }"
                    :ref="`node_question_text_${node.id}`"
                    :key="`node_question_text_${node.id}`"
                  ></v-text>
                </template>
              </v-group>
            </template>

            <template v-for="(line, index) in connections">
              <v-group :ref="`connection_${index}_group`" :key="`connection_${index}_group`">
                <v-text
                  v-if="showDebug"
                  :config="{
                    text: line.id,
                    x: line.points[0],
                    y: line.points[1]
                  }"
                >
                </v-text>
                <v-line
                  :config="{
                    stroke: line.isHover ? '#61a9de' : '#9e9e9e',
                    strokeWidth: line.isHover ? 4 : 3,
                    bezier: line.isBezier,
                    points: line.points,
                    tension: line.tension ? line.tension : 0
                  }"
                  @mouseover="onLineMouseOver(index, $event)"
                  @mouseleave="onLineMouseLeave(index, $event)"
                  @click="onEditConnection()"
                />
              </v-group>
            </template>

            <template v-for="(node, index) in nodes">
              <v-group
                :ref="`node_group_pointer_${node.id}`"
                :key="`node_group_pointer_${node.id}`"
              >
                <v-rect
                  :ref="'node_' + node.id"
                  :config="{
                    x: !isNaN(node.x) ? node.x : 0,
                    y: !isNaN(node.y) ? node.y : 0,
                    width: 300,
                    height: 60 + (node.height ? node.height : nodeHeight),
                    opacity: node.isHover || node.isSelect ? 1 : 0,
                    stroke: node.isSelect ? '#29b12f' : '#61a9de',
                    strokeWidth: 2,
                    cornerRadius: 10,
                    draggable: check_privilege
                  }"
                  @dragstart="onNodeMoveStart(index, $event)"
                  @dragmove="onNodeMove(index, $event)"
                  @dragend="onNodeMoveEnd(index, $event)"
                  @mouseover="onNodeMouseOver(index, $event)"
                  @mouseleave="onNodeMouseLeave(index, $event)"
                  @click="onNodeClick(index, $event)"
                  :key="'node_action_' + index"
                ></v-rect>
                <template v-if="node.type == 'api'">
                  <v-circle
                    :config="{
                      radius: 6,
                      y: checkNaN(node.y) + 60 + (node.messageHeight ? node.messageHeight / 2 : 0),
                      x: checkNaN(node.x) + 300,
                      fill: node.to != 0 ? '#61a9de' : 'white',
                      stroke: '#61a9de',
                      strokeWidth: 1,
                      type: 'point'
                    }"
                    @mouseover="
                      onPointMouseOver(
                        { from: node.id, index: index, type: 'api', text: '' },
                        $event
                      )
                    "
                    @mouseleave="onPointMouseLeave"
                    :ref="`node_api_${node.id}`"
                    :key="`node_api_${node.id}`"
                  ></v-circle>
                </template>
                <template v-else-if="node.type == 'random'">
                  <template
                    v-if="node.answer && node.answer.length > 0 && node.answer[0].length > 0"
                  >
                    <template v-for="(to, tindex) in node.answer[0][0].to">
                      <v-circle
                        :config="{
                          radius: 6,
                          y: checkNaN(node.y) + 60 + tindex * 30 + 15,
                          x: 270 + checkNaN(node.x) + 15,
                          fill: to != 0 ? '#61a9de' : 'white',
                          stroke: '#61a9de',
                          type: 'point'
                        }"
                        @mouseover="
                          onPointMouseOver(
                            {
                              from: node.id,
                              index: index,
                              type: 'random',
                              tindex: tindex
                            },
                            $event
                          )
                        "
                        @mouseleave="onPointMouseLeave"
                        :ref="`node_random_${node.id}_${tindex}`"
                        :key="`node_random_link_${node.id}_${tindex}`"
                      ></v-circle>
                    </template>
                  </template>
                </template>
                <template v-else-if="node.type == 'flow'"></template>
                <template v-else-if="node.type == 'savevariables'">
                  <v-circle
                    :config="{
                      radius: 6,
                      y: checkNaN(node.y) + 60 + (node.messageHeight ? node.messageHeight / 2 : 0),
                      x: checkNaN(node.x) + 300,
                      fill: node.to != 0 ? '#61a9de' : 'white',
                      stroke: '#61a9de',
                      strokeWidth: 1,
                      type: 'point'
                    }"
                    @mouseover="
                      onPointMouseOver(
                        { from: node.id, index: index, type: 'savevariables', text: '' },
                        $event
                      )
                    "
                    @mouseleave="onPointMouseLeave"
                    :ref="`node_savevariables_${node.id}`"
                    :key="`node_savevariables_${node.id}`"
                  ></v-circle>
                </template>
                <template v-else>
                  <template v-if="['condition'].includes(node.type) == false">
                    <v-rect
                      :config="{
                        width: 14,
                        height: 14,
                        y: checkNaN(node.y) + 60 + (node.height ? node.height : nodeHeight),
                        x: checkNaN(node.x) + 150,
                        fill: '#61a9de',
                        rotation: 45,
                        offset: {
                          x: 7,
                          y: 7
                        }
                      }"
                      @mouseover="
                        onPointMouseOver(
                          { from: node.id, index: index, type: 'text', text: '{default}' },
                          $event
                        )
                      "
                      @mouseleave="onPointMouseLeave"
                      :ref="`node_default_${node.id}`"
                      :key="`node_default_${node.id}`"
                    ></v-rect>
                  </template>
                  <template v-for="(answer, aindex) in node.answer">
                    <template v-for="(message, mindex) in answer">
                      <template v-if="message.type == 'text'"></template>
                      <template v-if="message.type == 'button'">
                        <template v-for="(button, bindex) in message.buttons">
                          <v-circle
                            v-if="button.type == 'postback'"
                            :config="{
                              radius: 6,
                              y:
                                (message.messageHeight ? message.messageHeight : 50) +
                                checkNaN(node.y) +
                                60 +
                                bindex * buttonHeight +
                                (message.y ? message.y : 0) +
                                buttonHeight / 2,
                              x: 270 + checkNaN(node.x) + 15,
                              fill: button.payload ? '#61a9de' : 'white',
                              stroke: '#61a9de',
                              type: 'point'
                            }"
                            @mouseover="
                              onPointMouseOver(
                                {
                                  from: node.id,
                                  index: index,
                                  type: 'postback',
                                  text: button.payload,
                                  aindex: aindex,
                                  mindex: mindex,
                                  bindex: bindex
                                },
                                $event
                              )
                            "
                            @mouseleave="onPointMouseLeave"
                            :ref="`node_button_${node.id}_${button.payload}`"
                            :key="`node_link_${node.id}_${aindex}_${mindex}_${bindex}`"
                          ></v-circle>
                        </template>
                      </template>
                      <template v-else-if="message.type == 'generic'">
                        <template v-for="(generic, gindex) in message.data">
                          <template v-for="(button, bindex) in generic.buttons">
                            <v-circle
                              v-if="button.type == 'postback'"
                              :config="{
                                radius: 6,
                                y:
                                  checkNaN(node.y) +
                                  60 +
                                  bindex * buttonHeight +
                                  (message.y ? message.y : 0) +
                                  buttonHeight / 2 +
                                  imageHeight +
                                  (generic.genericMessageHeight ? generic.genericMessageHeight : 0),
                                x: 270 + checkNaN(node.x) + 15 + gindex * 295,
                                fill: button.payload ? '#61a9de' : 'white',
                                stroke: '#61a9de',
                                type: 'point'
                              }"
                              @mouseover="
                                onPointMouseOver(
                                  {
                                    from: node.id,
                                    index: index,
                                    type: 'generic',
                                    text: button.payload,
                                    aindex: aindex,
                                    mindex: mindex,
                                    bindex: bindex,
                                    gindex: gindex
                                  },
                                  $event
                                )
                              "
                              @mouseleave="onPointMouseLeave"
                              :ref="`node_generic_${node.id}_${button.payload}`"
                              :key="
                                `node_generic_link_${node.id}_${aindex}_${mindex}_${gindex}_${bindex}`
                              "
                            ></v-circle>
                          </template>
                        </template>
                      </template>
                      <template v-else-if="message.type == 'condition'">
                        <template v-for="(condition, cindex) in message.condition">
                          <v-circle
                            :config="{
                              radius: 6,
                              y:
                                checkNaN(node.y) +
                                60 +
                                (condition.y ? condition.y : 0) +
                                (message.y ? message.y : 0) +
                                (condition.messageHeight ? condition.messageHeight / 2 : 0),
                              x: checkNaN(node.x) + 270 + 15,
                              fill: condition.to != 0 ? '#61a9de' : 'white',
                              stroke: '#61a9de',
                              strokeWidth: 1,
                              type: 'point'
                            }"
                            @mouseover="
                              onPointMouseOver(
                                {
                                  from: node.id,
                                  index: index,
                                  type: 'condition',
                                  text: '',
                                  cindex: cindex
                                },
                                $event
                              )
                            "
                            @mouseleave="onPointMouseLeave"
                            :ref="`node_condition_${node.id}_${cindex}`"
                            :key="`node_condition_${node.id}_${cindex}`"
                          ></v-circle>
                        </template>
                      </template>
                    </template>
                  </template>

                  <template v-if="node.userinput && ['start_node', 'node'].includes(node.type)">
                    <template v-if="node.choices && node.choices.list">
                      <template v-for="(choice, cindex) in node.choices.list">
                        <v-circle
                          :config="{
                            radius: 6,
                            y:
                              checkNaN(node.y) +
                              60 +
                              choice.y +
                              (choice.messageHeight ? choice.messageHeight / 2 : 0),
                            x: checkNaN(node.x) + 270 + 15,
                            fill: node.to != 0 ? '#61a9de' : 'white',
                            stroke: '#61a9de',
                            strokeWidth: 1,
                            type: 'point'
                          }"
                          @mouseover="
                            onPointMouseOver(
                              {
                                from: node.id,
                                index: index,
                                type: 'quick_reply',
                                text: choice.text
                              },
                              $event
                            )
                          "
                          @mouseleave="onPointMouseLeave"
                          :ref="`node_quick_reply_${node.id}_${choice.text}`"
                          :key="`node_quick_reply_${node.id}_${cindex}`"
                        ></v-circle>
                      </template>
                    </template>
                    <v-circle
                      :config="{
                        radius: 6,
                        y:
                          checkNaN(node.y) +
                          60 +
                          (node.userinput.y ? node.userinput.y : 0) +
                          (node.userinput.messageHeight ? node.userinput.messageHeight / 2 : 0),
                        x: checkNaN(node.x) + 15 + 270,
                        fill: node.userinput.hasUserInput ? '#61a9de' : 'white',
                        stroke: '#61a9de',
                        strokeWidth: 1,
                        type: 'point'
                      }"
                      @mouseover="
                        onPointMouseOver({ from: node.id, index: index, type: 'text' }, $event)
                      "
                      @mouseleave="onPointMouseLeave"
                      :ref="`node_input_${node.id}`"
                      :key="`node_input_${node.id}`"
                    ></v-circle>
                  </template>
                </template>

                <v-regular-polygon
                  :config="{
                    sides: 3,
                    radius: 10,
                    y: checkNaN(node.y) + 60 + (node.height ? node.height : nodeHeight) / 2,
                    x: !isNaN(node.x) ? node.x : 0,
                    fill: '#61a9de',
                    rotation: 90
                  }"
                  :ref="`connections_${node.id}`"
                  :key="`connections_${node.id}`"
                ></v-regular-polygon>
              </v-group>
            </template>

            <v-regular-polygon
              v-if="relationPointer"
              :config="{
                radius: isDragRelation ? 6 : 10,
                y: !isNaN(relationPointer.y) && relationPointer.y ? relationPointer.y : 0,
                x: !isNaN(relationPointer.x) && relationPointer.x ? relationPointer.x : 0,
                fill: '#61a9de',
                sides: isDragRelation ? 3 : 4,
                opacity: isDragRelation ? 1 : 0,
                scale: { x: 1.4, y: 1.4 },
                draggable: check_privilege,
                rotation: isDragRelation ? (arrowDirection == 'right' ? 90 : -90) : -45
              }"
              ref="cursor"
              @dragstart="onRelationStart"
              @dragmove="onRelationMove"
              @dragend="onRelationEnd"
            ></v-regular-polygon>

            <v-line
              :config="{
                stroke: '#61a9de',
                strokeWidth: 2,
                opacity: isDragRelation ? 1 : 0,
                bezier: true,
                points: relationLine
              }"
            />

            <v-circle
              v-if="lineDetail"
              :config="{
                radius: 15,
                x: !isNaN(lineDetail.x) && lineDetail.x ? lineDetail.x : 0,
                y: !isNaN(lineDetail.y) && lineDetail.y ? lineDetail.y : 0,
                fill: '#61a9de',
                visible: check_privilege && showToolConnection && lineDetail.type != 'start_node'
              }"
              @mouseover="onLineOptionMouseOver"
              @mouseleave="onLineOptionMouseLeave"
              @click="onEditConnection()"
            ></v-circle>
            <v-path
              v-if="lineDetail"
              :config="{
                x: !isNaN(lineDetail.x) && lineDetail.x ? lineDetail.x : 0,
                y: !isNaN(lineDetail.y) && lineDetail.y ? lineDetail.y : 0,
                data:
                  'm415.402344 495.421875-159.40625-159.410156-159.40625 159.410156c-22.097656 22.09375-57.921875 22.09375-80.019532 0-22.09375-22.097656-22.09375-57.921875 0-80.019531l159.410157-159.40625-159.410157-159.40625c-22.09375-22.097656-22.09375-57.921875 0-80.019532 22.097657-22.09375 57.921876-22.09375 80.019532 0l159.40625 159.410157 159.40625-159.410157c22.097656-22.09375 57.921875-22.09375 80.019531 0 22.09375 22.097657 22.09375 57.921876 0 80.019532l-159.410156 159.40625 159.410156 159.40625c22.09375 22.097656 22.09375 57.921875 0 80.019531-22.097656 22.09375-57.921875 22.09375-80.019531 0zm0 0',
                fill: 'white',
                scale: {
                  x: 0.025,
                  y: 0.025
                },
                offset: {
                  x: 250,
                  y: 250
                },
                visible:
                  check_privilege &&
                  showToolConnection &&
                  lineDetail.type != 'start_node' &&
                  lineDetail.type != 'input'
              }"
            ></v-path>

            <v-rect
              v-if="lineDetail"
              :config="{
                x: !isNaN(lineDetail.x) && lineDetail.x ? lineDetail.x : 0,
                y: !isNaN(lineDetail.y) && lineDetail.y ? lineDetail.y : 0,
                fill: 'white',
                stroke: lineDetail.strokeColor,
                width: lineDetail.width > 50 ? lineDetail.width : 50,
                height: lineDetail.height,
                visible:
                  check_privilege &&
                  showToolConnection &&
                  lineDetail.type == 'input' &&
                  lineDetail.type != 'start_node',
                cornerRadius: 10,
                offset: {
                  x: (lineDetail.width > 50 ? lineDetail.width : 50) / 2,
                  y: lineDetail.height / 2
                }
              }"
              @mouseover="onLineOptionMouseOver"
              @mouseleave="onLineOptionMouseLeave"
              @click="onEditConnection()"
            ></v-rect>
            <v-text
              v-if="lineDetail"
              :config="{
                text: lineDetail.text,
                padding: 10,
                x: !isNaN(lineDetail.x) && lineDetail.x ? lineDetail.x : 0,
                y: !isNaN(lineDetail.y) && lineDetail.y ? lineDetail.y : 0,
                visible: check_privilege && showToolConnection && lineDetail.type == 'input',
                offset: {
                  x: lineDetail.width / 2,
                  y: lineDetail.height / 2
                }
              }"
              @mouseover="onLineOptionMouseOver"
              @mouseleave="onLineOptionMouseLeave"
              @click="onEditConnection()"
              ref="line_detail"
            ></v-text>
            <v-rect
              v-if="lineDetail"
              :config="{
                x: !isNaN(lineDetail.x) && lineDetail.x ? lineDetail.x : 0,
                y:
                  (!isNaN(lineDetail.y) && lineDetail.y ? lineDetail.y : 0) + lineDetail.height - 2,
                fill: lineDetail.strokeColor,
                width: 30,
                height: 30,
                visible:
                  check_privilege &&
                  showToolConnection &&
                  lineDetail.type == 'input' &&
                  lineDetail.type != 'start_node',
                cornerRadius: [0, 0, 10, 10],
                offset: {
                  x: 30 / 2,
                  y: 30 / 2
                }
              }"
              @mouseover="onLineOptionMouseOver"
              @mouseleave="onLineOptionMouseLeave"
              @click="onEditConnection()"
            ></v-rect>

            <v-path
              v-if="lineDetail"
              :config="{
                x: !isNaN(lineDetail.x) && lineDetail.x ? lineDetail.x : 0,
                y:
                  (!isNaN(lineDetail.y) && lineDetail.y ? lineDetail.y : 0) + lineDetail.height - 2,
                data:
                  'm487.050781 24.917969c-33.304687-33.222657-87.210937-33.222657-120.511719 0l-337.457031 337.453125c-2.371093 2.375-3.992187 5.398437-4.652343 8.691406l-24.082032 120.445312c-1.882812 9.222657 4.0625 18.222657 13.285156 20.109376 2.253907.460937 4.574219.460937 6.828126 0l120.527343-24.097657c3.292969-.664062 6.316407-2.28125 8.691407-4.65625l337.457031-337.453125c33.183593-33.324218 33.148437-87.21875-.085938-120.492187zm-421.800781 349.484375 241.023438-241.023438 72.3125 72.3125-241.023438 241.027344zm265.121094-265.121094 12.066406-12.066406 72.316406 72.3125-12.066406 12.066406zm-278.757813 299.6875 51.386719 51.382812-64.234375 12.851563zm411.335938-287.640625-24.097657 24.101563-72.3125-72.316407 24.097657-24.097656c19.96875-19.96875 52.34375-19.96875 72.3125 0s19.96875 52.34375 0 72.3125zm0 0',
                fill: 'white',
                scale: {
                  x: 0.025,
                  y: 0.025
                },
                offset: {
                  x: 250,
                  y: 250
                },
                visible: check_privilege && showToolConnection && lineDetail.type == 'input'
              }"
            ></v-path>

            <v-rect
              v-if="selectionConfig"
              ref="selectionrect"
              :config="{
                x: !isNaN(selectionConfig.x) && selectionConfig.x ? selectionConfig.x : 0,
                y: !isNaN(selectionConfig.y) && selectionConfig.y ? selectionConfig.y : 0,
                height: selectionConfig.height,
                width: selectionConfig.width,
                visible: selectionConfig.visible,
                fill: '#9eff2040',
                stroke: '#9eff20'
              }"
            ></v-rect>
          </v-layer>
        </v-stage>
      </template>
    </div>
    <div
      style="position: absolute"
      v-if="showDeleteNode"
      class="pa-2"
      :style="{ top: optionPos.y + 'px', left: optionPos.x + 'px' }"
      @mouseover="onDeleteNodeMouseOver"
      @mouseleave="onDeleteNodeMouseLeave"
    >
      <v-btn fab depressed small class="extra-small ma-0" color="primary" @click="onDeleteNode">
        <v-icon>delete</v-icon>
      </v-btn>
    </div>

    <v-navigation-drawer v-model="showDial" right temporary fixed>
      <div class="pa-3">
        <v-btn class="ml-0 mr-0" depressed large style="width: 100%" @click.stop="addNode('node')">
          <v-icon class="mr-2">add_box</v-icon>Add Node
        </v-btn>
        <v-btn
          class="ml-0 mr-0"
          depressed
          :color="$store.state.colorlist.api"
          large
          style="width: 100%"
          @click.stop="addNode('api')"
        >
          <v-icon class="mr-2">http</v-icon>Add api
        </v-btn>
        <v-btn
          class="ml-0 mr-0"
          depressed
          :color="$store.state.colorlist.random"
          large
          style="width: 100%"
          @click.stop="addNode('random')"
        >
          <v-icon class="mr-2">shuffle</v-icon>Add Randomize
        </v-btn>
        <v-btn
          class="ml-0 mr-0"
          depressed
          :color="$store.state.colorlist.condition"
          large
          style="width: 100%"
          @click.stop="addNode('condition')"
        >
          <v-icon class="mr-2">call_split</v-icon>Add Condition
        </v-btn>
        <v-btn
          class="ml-0 mr-0"
          depressed
          :color="$store.state.colorlist.flow"
          large
          style="width: 100%"
          @click.stop="addNode('flow')"
        >
          <v-icon class="mr-2">account_tree</v-icon>Add Flow
        </v-btn>
        <v-btn
          class="ml-0 mr-0"
          depressed
          :color="$store.state.colorlist.savevariables"
          large
          style="width: 100%"
          @click.stop="addNode('savevariables')"
        >
          <v-icon class="mr-2">save</v-icon>Save variable
        </v-btn>
      </div>
    </v-navigation-drawer>
    <div style="position: absolute; right: 10px; top: 60px;" v-if="nodes.length > 0">
      <div v-if="check_privilege">
        <v-btn color="primary" fab dark @click="showDial = true">
          <v-icon>add</v-icon>
        </v-btn>
      </div>

      <div class="text-xs-right">
        <v-btn color="white" fab small @click="repositionStage">
          <v-icon>settings_overscan</v-icon>
        </v-btn>
      </div>
    </div>

    <div style="position: fixed; bottom: 0; left: 0; right: 0; text-align: center">
      <div
        v-if="holdNewNodeOnHand"
        style="    margin: auto;
    display: inline-block;
    padding: 10px;
    background: #00000066;
    border-radius: 10px,10px,0,0;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    color: white;"
      >
        Click on empty space to drop new node
      </div>
      <div
        v-else-if="isBeforePaste"
        style="    margin: auto;
    display: inline-block;
    padding: 10px;
    background: #00000066;
    border-radius: 10px,10px,0,0;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    color: white;"
      >
        Click on empty space to drop copy nodes
      </div>
    </div>
  </div>
</template>

<script>
import {cloneDeep} from 'lodash'
import ModalDialog from '@/components/elements/ModalDialog'
import IntentManage from './IntentManage'
import QuestionManage from './QuestionManage'
import ApiManage from './ApiManage'
import RandomManage from './RandomManage'
import ConditionManage from './ConditionManage'
import DefaultManage from './DefaultManage'
import FlowManage from './FlowManage'
import VariableManage from './VariableManage'
import { mapGetters, mapMutations } from 'vuex'
import api from '@/api'
import copyNodeMixin from '@/mixins/copyNodeMixin.js'
import AddButtonPersistentMenu from './AddButtonPersistentMenu'
export default {
  props: ['value', 'flow', 'search'],
  mixins: [copyNodeMixin],
  components: {
    ModalDialog,
    IntentManage,
    ApiManage,
    RandomManage,
    ConditionManage,
    DefaultManage,
    QuestionManage,
    FlowManage,
    VariableManage,
    AddButtonPersistentMenu
  },
  data() {
    return {
      showDebug: false,
      holdNewNodeOnHand: false,
      newNodeOnHand: null,
      mode: '',
      onHoldShift: false,
      onHoldCtrl: false,
      newNode: {
        type: 'start_node',
        intentname: 'Start Node',
        flowid: this.flow.id,
        x: 0,
        y: 0,
        question: '',
        connected_intents: [],
        answer: [],
        quick_reply: ''
      },
      showDial: false,
      optionPos: { x: 0, y: 0 },
      maxHeight: 3000,
      maxWidth: 3000,
      configKonva: {
        width: 1200,
        height: 1200,
        x: 0,
        y: 0,
        draggable: true,
        scale: {
          x: 1,
          y: 1
        }
      },
      nodeHeight: 50,
      buttonHeight: 40,
      imageHeight: 141,
      videoAndAudioHeight: 60,
      isDragRelation: false,
      relationPointer: {
        x: 0,
        y: 0
      },
      relationPointerStart: {
        x: 0,
        y: 0
      },
      relationLine: [0, 0, 0, 0, 0, 0, 0, 0],
      nodes: [],
      connections: [],
      dragItemId: null,
      currentNodeMouserOver: [],
      selectedNode: null,
      selectedConnection: null,
      selectedTargetNode: [],
      selectedQuestionText: null,
      showEditNode: false,
      showEditApi: false,
      showEditRandom: false,
      showEditDefault: false,
      dragNodeStart: null,
      hoverNode: null,
      arrowDirection: 'right',
      showDeleteNode: false,
      showToolConnection: false,
      setTimeoutDeleteNode: null,
      setTimeoutToolConnection: null,
      showEditText: false,
      toolConnectionPos: { x: 0, y: 0 },
      showLineDetail: false,
      showEditCondition: false,
      lineDetail: {
        x: 0,
        y: 0,
        text: '',
        height: 1,
        width: 1,
        strokeColor: 'black',
        type: ''
      },
      showEditFlow: false,
      showConnection: false,
      posStart: { x: 0, y: 0 },
      posNow: { x: 0, y: 0 },
      selectionConfig: {},
      cursorPointer: {
        x: 0,
        y: 0
      },
      selectedArea: {
        x: 0,
        y: 0,
        height: 1,
        width: 1,
        visible: false
      },
      showEditVariable: false,
      isBeforePaste: false,
      loading: true,
      images: {},
      updateStageTimeout: null,
      showEditPersistent: false,
      tmpPersistentMenu: [],
      persistentConnections: [],
      check_privilege: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      loadingApiList: 'getLoadingApiList',
      apis: 'getApiList',
      copiedNodes: 'getCopyNodes',
      loadingPersistentMenu: 'getLoadingPersistentMenu',
      persistentMenu: 'getPersistentMenu'
    })
  },
  async mounted() {
    var vm = this
    window.addEventListener('keyup', this.onKeyUp)
    window.addEventListener('keydown', this.onKeyDown)
    window.addEventListener('focus', this.onFocusWindow)

    vm.nodes = vm.value
    vm.$set(vm.configKonva, 'x', vm.flow.x)
    vm.$set(vm.configKonva, 'y', vm.flow.y)
    vm.$set(vm.configKonva, 'scale', {
      x: vm.flow.zoom,
      y: vm.flow.zoom
    })

    this.check_privilege =
      this.$store.state.superadmin.includes(this.$store.state.userid) ||
      this.flow.createdby == this.$store.state.userid ||
      this.flow.owneradminid == this.$store.state.userid ||
      this.flow.isedit == true

    await this.renderNodes(true)
  },
  destroyed() {
    window.removeEventListener('keyup', this.onKeyUp)
    window.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('focus', this.onFocusWindow)
  },
  methods: {
    handleGetFileNameFromUrl(val) {
      if (val) {
        const url = val
        const filename = url.substring(url.lastIndexOf('/') + 1).split('?')[0]
        return filename
      } else {
        return ''
      }
    },
    onMoveButton: function(index, direction, item) {
      if (direction == 'up') {
        this.tmpPersistentMenu.splice(index, 0, this.tmpPersistentMenu.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        this.tmpPersistentMenu.splice(index, 0, this.tmpPersistentMenu.splice(index + 1, 1)[0])
      }

      // vm.$emit('input', vm.bubbleMessages)
    },
    async editPersistentMenu() {
      this.tmpPersistentMenu = cloneDeep(this.persistentMenu)
      this.showEditPersistent = true
    },
    addMenu() {
      if (this.tmpPersistentMenu.length < 20) {
        this.tmpPersistentMenu.push({
          title: '',
          type: 'postback',
          payload: '',
          isShow: true
        })
      }
    },
    deleteMenu(index) {
      this.tmpPersistentMenu.splice(index, 1)
    },
    onCancelPersistent() {
      this.tmpPersistentMenu = cloneDeep(this.persistentMenu)
      this.showEditPersistent = false
    },
    async onSavePersistent() {
      this.$store.dispatch('loading')
      await this.$store.dispatch('savePersistentMenu', this.tmpPersistentMenu)
      await this.$store.dispatch('loadPersistentMenu', {
        pageid: this.selectedBot.pageid,
        isForceLoad: true
      })
      this.$store.dispatch('loading')
      this.showEditPersistent = false
      this.flash('Save Successful', 'success', {
        timeout: 3000
      })
      await this.$nextTick()
      this.renderNodes()
    },
    async renderNodes(isLoading = false) {
      if (isLoading) this.loading = true
      await this.$nextTick()
      this.onResize()
      await this.$nextTick()
      await this.beforeResizeMessage()
      if (isLoading) this.loading = false
      await this.$nextTick()
      await this.resizeMessage()
      await this.$nextTick()
      this.drawAllConnection()
    },
    checkNaN(val, optional = 1) {
      return !isNaN(val) ? val : optional
    },
    onFocusWindow() {
      this.onHoldShift = false
    },
    async onSaveEditVariable(payload) {
      this.showEditVariable = false

      var nodeIndex = this.nodes.findIndex(node => {
        return node.id == payload.id
      })

      if (nodeIndex != -1) {
        var vm = this
        this.$emit('updateNode', {
          payload: payload,
          oncomplete: async intent => {
            if (intent) this.$set(this.nodes, nodeIndex, intent)
            vm.selectedNode = null
            await vm.renderNodes()
          }
        })
      }
    },
    formatVariable(variables) {
      if (variables.length > 0) {
        return variables.map(el => {
          return {
            text: el.replace('=', ' = '),
            height: 0
          }
        })
      } else {
        return []
      }
    },
    onCancelEditVariable() {
      this.showEditVariable = false
    },
    repositionStage() {
      this.$set(this.configKonva, 'scale', { x: 1, y: 1 })
      this.$set(this.configKonva, 'x', 0)
      this.$set(this.configKonva, 'y', 0)
    },
    onKeyUp(e) {
      if (e.keyCode == 91 || e.keyCode == 17) {
        this.onHoldCtrl = false
        this.$forceUpdate()
      } else if (e.keyCode == 16) {
        this.onHoldShift = false
        this.$forceUpdate()
        return false
      }
    },
    onKeyDown(e) {
      if (e.keyCode == 8) {
        this.onDeleteSelectedNode()
      }
      if (e.keyCode == 91 || e.keyCode == 17) {
        this.onHoldCtrl = true
        this.$forceUpdate()
      }
      if (this.onHoldCtrl && e.keyCode == 67) {
        // copy
        var selected_nodes = this.nodes.filter(el => {
          return el.isSelect
        })
        this.$store.dispatch('setCopyNode', selected_nodes)
      }
      if (this.onHoldCtrl && e.keyCode == 86) {
        // paste
        this.beforePaste()
      }
      if (e.shiftKey) {
        this.onHoldShift = true
        this.$forceUpdate()
        return false
      }
    },
    beforePaste() {
      this.isBeforePaste = true
    },
    async onPasteNode(pos) {
      var vm = this
      this.$store.dispatch('loading')
      var oldNodes = this.copiedNodes.filter(node => {
        return node.type != 'start_node'
      })

      if (oldNodes.length > 0) {
        var destinations = oldNodes.map(el => {
          return {
            id: el.id,
            x: el.x,
            y: el.y
          }
        })
        var shortedDistance = this.findClosest(pos, destinations)
        // console.log(pos, shortedDistance)

        var distance = {
          x: pos.x - shortedDistance.x,
          y: pos.y - shortedDistance.y
        }

        oldNodes = cloneDeep(oldNodes)
        oldNodes = oldNodes.map(el => {
          return {
            ...el,
            x: parseInt(el.x + distance.x),
            y: parseInt(el.y + distance.y)
          }
        })
        var newNodes = await this.getCopyNode(oldNodes, this.flow.id)

        var updatePromises = newNodes.map(node => {
          return this.multipleUpdateNode(node)
        })
        let nodes = await Promise.all(updatePromises)
        this.nodes = this.nodes.concat(nodes)

        await vm.renderNodes()
      }
      this.$store.dispatch('loading')
    },
    multipleUpdateNode(node) {
      var vm = this
      return new Promise(resolve => {
        vm.$emit('updateNodeSilence', {
          payload: cloneDeep(node),
          oncomplete: async intent => {
            resolve(intent)
          }
        })
      })
    },
    findClosest(myPosition, destinations) {
      var closest = destinations[0]
      var shortestDistance = this.DistSquared(myPosition, destinations[0])
      for (let i = 0; i < destinations.length; i++) {
        var d = this.DistSquared(myPosition, destinations[i])
        if (d < shortestDistance) {
          closest = destinations[i]
          shortestDistance = d
        }
      }
      return closest
    },
    DistSquared(pt1, pt2) {
      var diffX = pt1.x - pt2.x
      var diffY = pt1.y - pt2.y
      return diffX * diffX + diffY * diffY
    },
    async onCancelEditFlow() {
      this.showEditFlow = false
      this.selectedNode = null
      await this.renderNodes()
    },
    async onSaveEditFlow(payload) {
      var vm = this
      vm.showEditFlow = false
      var nodeIndex = vm.nodes.findIndex(node => {
        return node.id == payload.id
      })
      if (nodeIndex != -1) {
        vm.$emit('updateNode', {
          payload: payload,
          oncomplete: async intent => {
            if (intent) vm.$set(vm.nodes, nodeIndex, intent)
            vm.selectedNode = null
            await vm.renderNodes()
          }
        })
      }
    },
    async onSaveStartNode(payload) {
      try {
        var data = payload
        data.connected_intents = JSON.stringify(payload.connected_intents)
        data.answer = JSON.stringify(payload.answer)
        this.$store.dispatch('loading')
        var response = await api.addNode(data)
        this.$store.commit('CLEAR_LOADING')
        if (response.data && response.data.length > 0) {
          var result = response.data[0]
          result.connected_intents = JSON.parse(result.connected_intents)
          result.answer = JSON.parse(result.answer)
          result.userinput = {
            from: 0,
            input: '',
            type: 'input'
          }
          this.nodes.push(result)
          await this.renderNodes()
        }
      } catch (error) {
        this.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async onCancelEditDefault() {
      this.showEditDefault = false
      this.selectedNode = null
      await this.renderNodes()
    },
    onSaveEditDefault(payload) {
      var vm = this
      vm.showEditDefault = false
      var nodeIndex = vm.nodes.findIndex(node => {
        return payload.id == node.id
      })
      if (nodeIndex != -1) {
        var defaultIndex = vm.nodes[nodeIndex].connected_intents.findIndex(connection => {
          return connection.text == '{default}' && connection.type == 'input'
        })
        if (vm.selectedTargetNode && vm.selectedTargetNode.length > 0) {
          if (defaultIndex != -1) {
            vm.$set(
              vm.nodes[nodeIndex].connected_intents[defaultIndex],
              'to',
              vm.selectedTargetNode[0]
            )
          } else {
            vm.nodes[nodeIndex].connected_intents.push({
              text: '{default}',
              to: vm.selectedTargetNode[0],
              type: 'input'
            })
          }
        }
        vm.$set(vm.nodes[nodeIndex], 'default_text', payload.default_text)
        vm.$set(
          vm.nodes[nodeIndex],
          'connected_intents',
          vm.sortDefault(vm.nodes[nodeIndex].connected_intents)
        )
        vm.$emit('updateNode', {
          payload: vm.nodes[nodeIndex],
          oncomplete: intent => {
            if (intent) vm.$set(vm.nodes, nodeIndex, intent)
            vm.renderNodes()
          }
        })
      }

      vm.selectedNode = null
    },
    async onCancelCondition() {
      this.showEditCondition = false
      this.$set(this.selectedNode.connected_intents, 0, this.selectedNode.answer[0][0])
      this.selectedNode = null
      await this.renderNodes()
    },
    onSaveCondition(payload) {
      var vm = this
      vm.showEditCondition = false
      var nodeIndex = vm.nodes.findIndex(node => {
        return node.id == payload.id
      })
      if (nodeIndex != -1) {
        vm.$emit('updateNode', {
          payload: payload,
          oncomplete: intent => {
            if (intent) vm.$set(vm.nodes, nodeIndex, intent)
            vm.selectedNode = null
            vm.renderNodes()
          }
        })
      }
    },
    onToolConnectionMouseOver() {},
    onToolConnectionMouseLeave() {},
    onEditConnection() {
      if (!this.check_privilege) return false
      if (this.selectedConnection.type == 'input' && this.selectedConnection.value == '{default}') {
        var nodeIndex = this.nodes.findIndex(node => {
          return node.id == this.selectedConnection.nodeId
        })
        if (nodeIndex != -1) {
          this.selectedTargetNode = [this.selectedConnection.to]
          var questionText = this.selectedConnection.value
          if (questionText) {
            this.selectedQuestionText = questionText
          } else {
            this.selectedQuestionText = ''
          }
          this.selectedNode = this.nodes[nodeIndex]
          this.selectedNode.isConnected = true
          this.showEditDefault = true
        }
      } else if (this.selectedConnection.type == 'input') {
        var nodeIndex = this.nodes.findIndex(node => {
          return node.id == this.selectedConnection.nodeId
        })
        if (nodeIndex != -1) {
          this.selectedTargetNode = [this.selectedConnection.to]
          var questionText = this.selectedConnection.value
          if (questionText) {
            this.selectedQuestionText = questionText
          } else {
            this.selectedQuestionText = ''
          }
          this.selectedNode = this.nodes[nodeIndex]
          this.selectedNode.isConnected = true
          this.showEditText = true
        }
      } else if (this.selectedConnection.type == 'start_node') {
      } else {
        this.onDeleteConnection()
      }
    },
    onDeleteConnection() {
      var vm = this
      vm.$swal({
        title: 'Do you want to delete this connection?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          var nodeIndex = vm.nodes.findIndex(node => {
            return node.id == vm.selectedConnection.nodeId
          })

          if (nodeIndex != -1) {
            if (vm.nodes[nodeIndex].type == 'condition') {
              if (
                vm.nodes[nodeIndex].answer &&
                vm.nodes[nodeIndex].answer.length > 0 &&
                vm.nodes[nodeIndex].answer[0].length > 0
              ) {
                var conditionIndex = vm.nodes[nodeIndex].answer[0][0].condition.findIndex(
                  condition => {
                    return condition.to == vm.selectedConnection.to
                  }
                )
                if (conditionIndex != -1) {
                  vm.$set(vm.nodes[nodeIndex].answer[0][0].condition[conditionIndex], 'to', 0)
                  vm.$set(
                    vm.nodes[nodeIndex].connected_intents,
                    0,
                    vm.nodes[nodeIndex].answer[0][0]
                  )
                }
              }
            } else if (vm.nodes[nodeIndex].type == 'api') {
              var apiIndex = vm.nodes[nodeIndex].connected_intents.findIndex(connection => {
                return connection.to == vm.selectedConnection.to
              })
              if (apiIndex != -1) {
                vm.nodes[nodeIndex].connected_intents.splice(apiIndex, 1)
              }
            }
            if (vm.nodes[nodeIndex].type == 'random') {
              if (
                vm.nodes[nodeIndex].answer &&
                vm.nodes[nodeIndex].answer.length > 0 &&
                vm.nodes[nodeIndex].answer[0].length > 0
              ) {
                var randomIndex = vm.nodes[nodeIndex].answer[0][0].to.findIndex(random => {
                  return random == vm.selectedConnection.to
                })
                if (randomIndex != -1) {
                  vm.$set(vm.nodes[nodeIndex].answer[0][0].to, randomIndex, 0)
                  vm.$set(
                    vm.nodes[nodeIndex].connected_intents,
                    0,
                    vm.nodes[nodeIndex].answer[0][0]
                  )
                }
              }
            } else {
              var connectionIndex = vm.nodes[nodeIndex].connected_intents.findIndex(connection => {
                return (
                  connection.text == vm.selectedConnection.value &&
                  connection.to == vm.selectedConnection.to &&
                  connection.type == vm.selectedConnection.type
                )
              })
              if (connectionIndex != -1) {
                if (
                  vm.selectedConnection.value == '{default}' &&
                  vm.selectedConnection.type == 'input'
                ) {
                  vm.$set(vm.nodes[nodeIndex], 'default_text', '')
                }
                vm.nodes[nodeIndex].connected_intents.splice(connectionIndex, 1)
              }
            }
          }

          vm.$emit('updateNode', {
            payload: vm.nodes[nodeIndex],
            oncomplete: intent => {
              vm.showEditText = false
              if (intent) vm.$set(vm.nodes, nodeIndex, intent)
              vm.renderNodes()
            }
          })
        }
      })
    },
    async onCancelEditText() {
      this.selectedQuestionText = ''
      this.showEditText = false
      this.selectedNode = null
      await this.renderNodes()
    },
    onSaveEditText() {
      var vm = this
      if (vm.selectedQuestionText != '') {
        var nodeIndex = vm.nodes.findIndex(el => {
          return el.id == vm.selectedNode.id
        })
        // console.log(nodeIndex, vm.selectedTargetNode)
        if (nodeIndex != -1 && vm.selectedTargetNode && vm.selectedTargetNode.length > 0) {
          if (vm.nodes[nodeIndex].connected_intents) {
            var questionIndex = vm.nodes[nodeIndex].connected_intents.findIndex(el => {
              return el.type == 'input' && el.to == vm.selectedTargetNode[0]
            })

            if (questionIndex != -1) {
              vm.$set(vm.nodes[nodeIndex].connected_intents, questionIndex, {
                type: 'input',
                to: vm.selectedTargetNode[0],
                text: vm.selectedQuestionText
              })
            } else {
              vm.nodes[nodeIndex].connected_intents.push({
                type: 'input',
                to: vm.selectedTargetNode[0],
                text: vm.selectedQuestionText
              })
            }
          } else {
            vm.nodes[nodeIndex].connected_intents.push({
              type: 'input',
              to: vm.selectedTargetNode[0],
              text: vm.selectedQuestionText
            })
          }
          vm.$set(
            vm.nodes[nodeIndex],
            'connected_intents',
            vm.sortDefault(vm.nodes[nodeIndex].connected_intents)
          )
          vm.$emit('updateNode', {
            payload: vm.nodes[nodeIndex],
            oncomplete: intent => {
              // console.log('save text: ', intent)
              vm.showEditText = false
              if (intent) vm.$set(vm.nodes, nodeIndex, intent)
              vm.renderNodes()
            }
          })
        }
        vm.selectedQuestionText = ''
      } else {
        vm.showEditText = false
      }
      vm.selectedNode = null
    },
    async onCancelApi() {
      this.showEditApi = false
      this.selectedNode = null
      await this.renderNodes()
    },
    onSaveApi(payload) {
      var vm = this
      vm.showEditApi = false
      var nodeIndex = vm.nodes.findIndex(el => {
        return el.id == payload.id
      })
      if (nodeIndex != -1) {
        vm.$emit('updateNode', {
          payload: vm.nodes[nodeIndex],
          oncomplete: intent => {
            if (intent) vm.$set(vm.nodes, nodeIndex, intent)
            vm.renderNodes()
          }
        })
      }
      vm.selectedNode = null
    },
    async onCancelRandom() {
      this.showEditRandom = false
      this.selectedNode = null
      await this.renderNodes()
    },
    onSaveRandom(payload) {
      var vm = this

      vm.showEditRandom = false
      var nodeIndex = vm.nodes.findIndex(node => {
        return node.id == payload.id
      })
      if (nodeIndex != -1) {
        vm.$emit('updateNode', {
          payload: payload,
          oncomplete: intent => {
            if (intent) vm.$set(vm.nodes, nodeIndex, intent)
            vm.$set(vm.nodes[nodeIndex].connected_intents, 0, vm.nodes[nodeIndex].answer[0][0])
            vm.renderNodes()
          }
        })
      }
      vm.selectedNode = null
    },
    async onCancelIntent() {
      this.showEditNode = false
      this.selectedNode = null
      await this.renderNodes()
    },
    async onSaveIntent(payload) {
      var vm = this
      vm.showEditNode = false
      var nodeIndex = vm.nodes.findIndex(node => {
        return node.id == payload.id
      })
      if (nodeIndex != -1) {
        let data = null
        data = {
          ...payload,
          answer: payload.answer.map(bubble => {
            return bubble.filter(subBubble => {
              if (subBubble.type == 'video' || subBubble.type == 'audio') {
                return subBubble.source != ''
              } else {
                return true
              }
            })
          })
        }
        if (data) {
          vm.$emit('updateNode', {
            payload: data,
            oncomplete: intent => {
              if (intent) vm.$set(vm.nodes, nodeIndex, intent)
              vm.renderNodes()
            }
          })
        }
      }
      vm.selectedNode = null
    },
    onRelationStart(e) {
      if (!this.check_privilege) return false
      this.$refs.stage.getNode().container().style.cursor = 'pointer'
      this.$set(this.relationPointerStart, 'x', e.target.x())
      this.$set(this.relationPointerStart, 'y', e.target.y())
      this.isDragRelation = true
    },
    onRelationMove(e) {
      var vm = this
      if (!this.check_privilege) return false
      var pos = this.$refs.stage.getNode().getPointerPosition()
      var cursor = this.$refs.cursor.getStage()
      vm.currentNodeMouserOver.map(nodeId => {
        vm.$refs[`node_group_${nodeId}`][0].getNode().clearCache()
        vm.$refs[`node_group_pointer_${nodeId}`][0].getNode().clearCache()
      })
      this.currentNodeMouserOver = []
      this.nodes.map((node, index) => {
        var shape = this.$refs['node_' + node.id][0].getStage()
        if (this.hitCheck(shape, cursor)) {
          this.$refs[`node_group_${node.id}`][0].getNode().clearCache()
          this.$refs[`node_group_pointer_${node.id}`][0].getNode().clearCache()
          if (this.currentNodeMouserOver.includes(node.id)) {
            // var cindex = this.currentNodeMouserOver.findIndex(el => {
            //   return el == node.id
            // })
            // if (cindex > -1) {
            //   this.currentNodeMouserOver.splice(cindex, 1)
            // }
          } else {
            this.currentNodeMouserOver.push(node.id)
          }
        }
      })
      this.$nextTick(() => {
        vm.currentNodeMouserOver.map(nodeId => {
          vm.$refs[`node_group_${nodeId}`][0].getNode().cache()
          vm.$refs[`node_group_pointer_${nodeId}`][0].getNode().cache()
        })
      })

      this.$set(this.relationPointer, 'x', e.target.x())
      this.$set(this.relationPointer, 'y', e.target.y())
      if (this.relationPointerStart.x > this.relationPointer.x) {
        this.arrowDirection = 'left'
      } else {
        this.arrowDirection = 'right'
      }
      var points = this.bezierCurveLine([
        this.relationPointerStart.x,
        this.relationPointerStart.y,
        this.relationPointer.x,
        this.relationPointer.y
      ])
      this.relationLine = points
    },
    onRelationEnd(e) {
      var vm = this
      if (!this.check_privilege) return false
      this.$refs.stage.getNode().container().style.cursor = 'default'
      var pos = vm.$refs.stage.getNode().getPointerPosition()
      var cursor = vm.$refs.cursor.getStage()
      vm.currentNodeMouserOver.map(nodeId => {
        try {
          vm.$refs[`node_group_${nodeId}`][0].getNode().cache()
          vm.$refs[`node_group_pointer_${nodeId}`][0].getNode().cache()
        } catch (error) {
          console.error(`node: ${nodeId}`, error)
        }
      })
      // console.log('before', vm.currentNodeMouserOver)
      vm.currentNodeMouserOver = []
      var isHit = false
      vm.nodes.map(node => {
        var shape = vm.$refs['node_' + node.id][0].getStage()
        if (vm.hitCheck(shape, cursor)) {
          isHit = true
          if (vm.currentNodeMouserOver.includes(node.id)) {
          } else {
            vm.currentNodeMouserOver.push(node.id)
          }
        }
      })
      if (vm.dragNodeStart) {
        if (isHit) {
          if (vm.dragNodeStart.type == 'text') {
            vm.selectedTargetNode = vm.currentNodeMouserOver
            vm.nodes.map(node => {
              if (node.id == vm.dragNodeStart.from) {
                if (vm.dragNodeStart.text == '{default}') {
                  vm.selectedNode = node
                  vm.showEditDefault = true
                  // default_text
                } else {
                  if (vm.currentNodeMouserOver[0] == vm.dragNodeStart.from) {
                    return false
                  }
                  if (
                    node.connected_intents &&
                    typeof node.connected_intents === 'object' &&
                    node.connected_intents.length > 0
                  ) {
                    var questionText = node.connected_intents.find(connection => {
                      return (
                        connection.type == 'input' &&
                        connection.to == vm.currentNodeMouserOver[0] &&
                        connection.value != '{default}'
                      )
                    })

                    if (questionText) {
                      vm.selectedQuestionText = questionText.text
                    } else {
                      vm.selectedQuestionText = ''
                    }
                  } else {
                    vm.selectedQuestionText = ''
                  }
                  vm.selectedNode = node
                  if (vm.selectedQuestionText == '') {
                    vm.selectedNode.isConnected = false
                  } else {
                    vm.selectedNode.isConnected = true
                  }
                  vm.showEditText = true
                }
                return false
              }
            })
            vm.renderNodes()
          } else {
            vm.nodes.map((node, index) => {
              if (node.id == vm.dragNodeStart.from) {
                if (vm.currentNodeMouserOver && vm.currentNodeMouserOver.length > 0) {
                  if (vm.currentNodeMouserOver[0] == vm.dragNodeStart.from) {
                    return false
                  }
                  if (vm.dragNodeStart.type == 'postback') {
                    var findOldButton = true
                    while (findOldButton) {
                      var oldButtonIndex = vm.nodes[index].connected_intents.findIndex(connect => {
                        return connect.type == 'button' && connect.text == vm.dragNodeStart.text
                      })
                      if (oldButtonIndex != -1) {
                        vm.nodes[index].connected_intents.splice(oldButtonIndex, 1)
                      } else {
                        findOldButton = false
                      }
                    }
                    vm.nodes[index].connected_intents.push({
                      to: vm.currentNodeMouserOver[0],
                      type: 'button',
                      text: vm.dragNodeStart.text
                    })
                  } else if (vm.dragNodeStart.type == 'quick_reply') {
                    var findOldButton = true
                    while (findOldButton) {
                      var oldButtonIndex = vm.nodes[index].connected_intents.findIndex(connect => {
                        return (
                          connect.type == 'quick_reply' && connect.text == vm.dragNodeStart.text
                        )
                      })
                      if (oldButtonIndex != -1) {
                        vm.nodes[index].connected_intents.splice(oldButtonIndex, 1)
                      } else {
                        findOldButton = false
                      }
                    }
                    vm.nodes[index].connected_intents.push({
                      to: vm.currentNodeMouserOver[0],
                      type: 'quick_reply',
                      text: vm.dragNodeStart.text
                    })
                  } else if (vm.dragNodeStart.type == 'generic') {
                    var findOldButton = true
                    while (findOldButton) {
                      var oldButtonIndex = vm.nodes[index].connected_intents.findIndex(connect => {
                        return connect.type == 'generic' && connect.text == vm.dragNodeStart.text
                      })
                      if (oldButtonIndex != -1) {
                        vm.nodes[index].connected_intents.splice(oldButtonIndex, 1)
                      } else {
                        findOldButton = false
                      }
                    }
                    vm.nodes[index].connected_intents.push({
                      to: vm.currentNodeMouserOver[0],
                      type: 'generic',
                      text: vm.dragNodeStart.text
                    })
                  } else if (vm.dragNodeStart.type == 'random') {
                    vm.$set(
                      vm.nodes[index].answer[0][0].to,
                      vm.dragNodeStart.tindex,
                      vm.currentNodeMouserOver[0]
                    )
                    vm.nodes[index].connected_intents = [vm.nodes[index].answer[0][0]]
                  } else if (vm.dragNodeStart.type == 'condition') {
                    var targetNode = vm.nodes.find(tnode => {
                      return tnode.id == vm.currentNodeMouserOver[0]
                    })
                    if (targetNode) {
                      vm.$set(
                        vm.nodes[index].answer[0][0].condition[vm.dragNodeStart.cindex],
                        'to',
                        vm.currentNodeMouserOver[0]
                      )
                      vm.nodes[index].connected_intents = [
                        {
                          condition: vm.nodes[index].answer[0][0].condition,
                          type: 'condition'
                        }
                      ]
                    }
                  } else if (vm.dragNodeStart.type == 'api') {
                    vm.nodes[index].connected_intents = [
                      {
                        to: vm.currentNodeMouserOver[0],
                        type: 'api'
                      }
                    ]
                  } else if (vm.dragNodeStart.type == 'savevariables') {
                    vm.nodes[index].connected_intents = [
                      {
                        to: vm.currentNodeMouserOver[0],
                        type: 'savevariables'
                      }
                    ]
                  }

                  vm.$emit('updateNode', {
                    payload: vm.nodes[index],
                    oncomplete: intent => {
                      // console.log(vm.nodes, vm.nodes[index], index, intent)
                      if (intent) vm.$set(vm.nodes, index, intent)
                      // console.log('oncomplete')
                      vm.$nextTick(() => {
                        vm.renderNodes()
                      })
                    }
                  })
                }
                return false
              }
            })
          }
        } else {
        }
      }

      vm.currentNodeMouserOver = []
      vm.$set(vm.relationPointer, 'x', vm.relationPointerStart.x)
      vm.$set(vm.relationPointer, 'y', vm.relationPointerStart.y)
      vm.isDragRelation = false
    },
    onStageClick(e) {},
    onStageMouseDown(e) {
      // console.log(e)
      this.$set(this.selectedArea, 'visible', false)
      var selected_nodes = this.nodes.filter(el => {
        return el.isSelect
      })
      if (this.onHoldShift) {
        this.mode = 'drawing'
        if (this.check_privilege) {
          var pos = this.getRelativePointerPosition(this.$refs.stage.getNode())
          this.startDrag({
            x: pos.x * this.configKonva.scale.x,
            y: pos.y * this.configKonva.scale.y
          })
        }
      } else if (selected_nodes && selected_nodes.length > 0) {
        this.nodes.map((node, index) => {
          this.$set(this.nodes[index], 'isSelect', false)
        })
      }
    },
    onStageMouseMove(e) {
      var pos = this.getRelativePointerPosition(this.$refs.stage.getNode())
      this.cursorPointer = pos
      if (this.onHoldShift) {
        if (this.mode === 'drawing') {
          // console.log(e)
          if (this.check_privilege) {
            this.updateDrag({
              x: pos.x * this.configKonva.scale.x,
              y: pos.y * this.configKonva.scale.y
            })
          }
        }
      }
    },
    onStageMouseUp(e) {
      // console.log(e)
      var vm = this

      this.mode = ''
      // r2.visible(false);

      var nodes = this.nodes.filter(node => {
        return node.isSelect
      })

      this.updateSelectArea(nodes)

      var pos = this.getRelativePointerPosition(this.$refs.stage.getNode())
      if (this.holdNewNodeOnHand) {
        this.$swal({
          title: 'Do you want to create?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            vm.createNewNode({
              x: pos.x,
              y: pos.y
            })
          }
        })
      } else if (this.isBeforePaste) {
        this.$swal({
          title: 'Do you want to paste?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            vm.onPasteNode({
              x: pos.x,
              y: pos.y
            })
          }
          vm.isBeforePaste = false
        })
      }

      // s1.draw();
      this.$set(this.selectionConfig, 'visible', false)
      this.$set(this.selectionConfig, 'x', 0)
      this.$set(this.selectionConfig, 'y', 0)
      this.$set(this.selectionConfig, 'width', 1)
      this.$set(this.selectionConfig, 'height', 1)
    },
    updateSelectArea(nodes) {
      var posStart = { x: 0, y: 0 }
      var posEnd = { x: 0, y: 0 }
      if (nodes && nodes.length > 0) {
        nodes.map((node, index) => {
          var shape = this.$refs[`node_${node.id}`][0].getStage()
          if (index == 0) {
            posStart.x = shape.x()
            posStart.y = shape.y()
            posEnd.x = shape.x() + shape.width()
            posEnd.y = shape.y() + shape.height()
          } else {
            posStart.x = shape.x() < posStart.x ? shape.x() : posStart.x
            posStart.y = shape.y() < posStart.y ? shape.y() : posStart.y
            posEnd.x = shape.x() + shape.width() > posEnd.x ? shape.x() + shape.width() : posEnd.x
            posEnd.y = shape.y() + shape.height() > posEnd.y ? shape.y() + shape.height() : posEnd.y
          }
        })
        var posRect = this.reverse(posStart, posEnd)
        this.$set(this.selectedArea, 'x', posRect.x1 - 15)
        this.$set(this.selectedArea, 'y', posRect.y1 - 15)
        this.$set(this.selectedArea, 'width', posRect.x2 - posRect.x1 + 30)
        this.$set(this.selectedArea, 'height', posRect.y2 - posRect.y1 + 30)
        this.$set(this.selectedArea, 'visible', true)
      } else {
        this.$set(this.selectedArea, 'visible', false)
      }
    },
    startDrag(posIn) {
      this.posStart = {
        x: posIn.x / this.configKonva.scale.x,
        y: posIn.y / this.configKonva.scale.y
      }
      this.posNow = { x: posIn.x / this.configKonva.scale.x, y: posIn.y / this.configKonva.scale.y }
    },
    updateDrag(posIn) {
      // update rubber rect position
      this.posNow = { x: posIn.x / this.configKonva.scale.x, y: posIn.y / this.configKonva.scale.y }
      var posRect = this.reverse(this.posStart, this.posNow)
      this.$set(this.selectionConfig, 'x', posRect.x1)
      this.$set(this.selectionConfig, 'y', posRect.y1)
      this.$set(this.selectionConfig, 'width', posRect.x2 - posRect.x1)
      this.$set(this.selectionConfig, 'height', posRect.y2 - posRect.y1)
      this.$set(this.selectionConfig, 'visible', true)

      // run the collision check loop
      this.$nextTick(() => {
        var selection = this.$refs.selectionrect.getStage()
        for (let i = 0; i < this.nodes.length; i = i + 1) {
          var shape = this.$refs[`node_${this.nodes[i].id}`][0].getStage()
          if (this.hitCheck(shape, selection)) {
            this.$set(this.nodes[i], 'isSelect', true)
          } else {
            this.$set(this.nodes[i], 'isSelect', false)
          }
        }
      })

      // s1.draw() // redraw any changes.
    },
    reverse(r1, r2) {
      var r1x = r1.x,
        r1y = r1.y,
        r2x = r2.x,
        r2y = r2.y,
        d
      if (r1x > r2x) {
        d = Math.abs(r1x - r2x)
        r1x = r2x
        r2x = r1x + d
      }
      if (r1y > r2y) {
        d = Math.abs(r1y - r2y)
        r1y = r2y
        r2y = r1y + d
      }
      return { x1: r1x, y1: r1y, x2: r2x, y2: r2y } // return the corrected rect.
    },
    getRelativePointerPosition(node) {
      // the function will return pointer position relative to the passed node
      var transform = node.getAbsoluteTransform().copy()
      // to detect relative position we need to invert transform
      transform.invert()

      // get pointer (say mouse or touch) position
      var pos = node.getStage().getPointerPosition()

      // now we find relative point
      return transform.point(pos)
    },
    async addNode(type) {
      var vm = this
      var allPos = this.getPos()
      var pos = {
        x: allPos ? allPos.posEnd.x + 100 : 0,
        y: allPos ? allPos.posStart.y : 0
      }

      // console.log(pos)
      if (type == 'node') {
        var data = {
          type: 'node',
          intentname: 'Node ' + vm.nodes.length,
          flowid: vm.flow.id,
          x: pos.x,
          y: pos.y,
          question: '',
          connected_intents: '[]',
          answer: '[]',
          quick_reply: ''
        }
      } else if (type == 'api') {
        var data = {
          type: 'api',
          intentname: 'Api ' + vm.nodes.length,
          flowid: vm.flow.id,
          x: pos.x,
          y: pos.y,
          question: '',
          connected_intents: '[]',
          answer: '[]',
          quick_reply: ''
        }
      } else if (type == 'random') {
        var data = {
          type: 'random',
          intentname: 'Random ' + vm.nodes.length,
          flowid: vm.flow.id,
          x: pos.x,
          y: pos.y,
          question: '',
          connected_intents: '[]',
          answer: '[]',
          quick_reply: ''
        }
      } else if (type == 'condition') {
        var data = {
          type: 'condition',
          intentname: 'condition ' + vm.nodes.length,
          flowid: vm.flow.id,
          x: pos.x,
          y: pos.y,
          question: '',
          connected_intents: '[]',
          answer: '[]',
          quick_reply: ''
        }
      } else if (type == 'flow') {
        var data = {
          type: 'flow',
          intentname: 'flow ' + vm.nodes.length,
          flowid: vm.flow.id,
          x: pos.x,
          y: pos.y,
          question: '',
          connected_intents: '[]',
          answer: '[]',
          quick_reply: ''
        }
      } else if (type == 'savevariables') {
        var data = {
          type: 'savevariables',
          intentname: 'Variable ' + vm.nodes.length,
          flowid: vm.flow.id,
          x: pos.x,
          y: pos.y,
          question: '',
          connected_intents: '[]',
          answer: '[]',
          quick_reply: ''
        }
      }
      this.showDial = false
      this.holdNewNodeOnHand = true
      this.newNodeOnHand = data
    },
    async createNewNode(pos) {
      this.holdNewNodeOnHand = false

      this.$store.dispatch('loading')
      var data = this.newNodeOnHand
      data.x = pos ? parseInt(pos.x) : 0
      data.y = pos ? parseInt(pos.y) : 0

      try {
        var response = await api.addNode(data)
        if (response.data && response.data.length > 0) {
          var result = response.data[0]
          result.question = ''
          result.connected_intents = []
          result.answer = []
          result.userinput = {
            from: 0,
            input: '',
            type: 'input'
          }
          this.nodes.push(result)
          this.$nextTick(() => {
            this.showDial = false
            this.beforeResizeMessage().then(() => {
              this.resizeMessage().then(() => {})
            })
          })
        }
      } catch (error) {
        console.error(error)
      }

      this.newNodeOnHand = null
      this.$store.dispatch('loading')

      // this.$set(this.configKonva, 'scale', { x: 1, y: 1 })
      // this.$nextTick(() => {
      //   this.$set(this.configKonva, 'x', -pos.x - 100 + this.configKonva.width / 2)
      //   this.$set(this.configKonva, 'y', -pos.y + this.configKonva.height / 2)
      // })
    },
    sortDefault(connections) {
      var newConnnections = connections.sort((a, b) => {
        if (a.type == 'input' && a.value == '{default}') {
          return -1
        } else {
          return 1
        }
      })
      return newConnnections
    },
    getPos() {
      var posStart = { x: 0, y: 0 }
      var posEnd = { x: 0, y: 0 }
      if (this.nodes && this.nodes.length > 0) {
        this.nodes.map((node, index) => {
          var shape = this.$refs[`node_${node.id}`][0].getStage()
          if (index == 0) {
            posStart.x = shape.x()
            posStart.y = shape.y()
            posEnd.x = shape.x() + shape.width()
            posEnd.y = shape.y() + shape.height()
          } else {
            posStart.x = shape.x() < posStart.x ? shape.x() : posStart.x
            posStart.y = shape.y() < posStart.y ? shape.y() : posStart.y
            posEnd.x = shape.x() + shape.width() > posEnd.x ? shape.x() + shape.width() : posEnd.x
            posEnd.y = shape.y() + shape.height() > posEnd.y ? shape.y() + shape.height() : posEnd.y
          }
        })
        return {
          posStart: posStart,
          posEnd: posEnd
        }
      } else {
        return null
      }
    },
    onPointMouseOver(payload, e) {
      if (!this.check_privilege) return false
      this.$refs.stage.getNode().container().style.cursor = 'pointer'
      this.$set(this.relationPointer, 'x', e.target.x())
      this.$set(this.relationPointer, 'y', e.target.y())
      e.target.to({
        scaleX: 1.4,
        scaleY: 1.4,
        duration: 0.1
      })
      // console.log(payload)
      this.dragNodeStart = payload
    },
    onPointMouseLeave(e) {
      if (!this.check_privilege) return false
      this.$refs.stage.getNode().container().style.cursor = 'default'
      e.target.to({
        scaleX: 1,
        scaleY: 1,
        duration: 0.1
      })
    },
    onStageDragStart(e) {
      // console.log(e)
      // e.evt.preventDefault()
      // if (e.target instanceof Konva.Stage) {
      //   if (e.evt.shiftKey) {
      //     e.target.stopDrag()
      //     console.log("don't drag in this case!")
      //   } else {
      //     console.log(e.target)
      //     console.log('normally drag')
      //     // this.configKonva.x = e.currentTarget.getPointerPosition().x
      //     // this.configKonva.y = e.currentTarget.getPointerPosition().y
      //   }
      // } else {
      //   // e.target.stopDrag()
      // }
    },
    onStageDragEnd(e) {
      // e.evt.preventDefault()
      if (e.target instanceof Konva.Stage) {
        if (e.evt && e.evt.shiftKey) {
          e.target.stopDrag()
        } else {
          if (this.updateStageTimeout) {
            clearTimeout(this.updateStageTimeout)
          }

          this.updateStageTimeout = setTimeout(() => {
            this.$emit('onFlowEdit', {
              x: e.currentTarget.x(),
              y: e.currentTarget.y(),
              zoom: 1
            })
          }, 3000)

          // this.configKonva.x = e.currentTarget.x()
          // this.configKonva.y = e.currentTarget.y()
        }
      }
    },
    beforeResizeMessage() {
      var vm = this
      var nodes = []
      return new Promise(async resolve => {
        nodes = cloneDeep(vm.nodes)
        try {
          var promises = nodes.map(async (el, index) => {
            if (el.quick_reply != null && el.quick_reply != '') {
              var choices = el.quick_reply.split(',')
              var tmpChoice = []
              tmpChoice = choices.map(choice => {
                return {
                  text: choice,
                  y: 0,
                  height: 0
                }
              })

              nodes[index].choices = {
                list: tmpChoice,
                y: 0,
                height: 0
              }
            } else {
              nodes[index].choices = {
                list: [],
                y: 0,
                height: 0
              }
            }
            if (el.answer) {
              for (let aindex = 0; aindex < el.answer.length; aindex++) {
                const answer = el.answer[aindex]
                for (let mindex = 0; mindex < answer.length; mindex++) {
                  const message = answer[mindex]
                  if (message.type == 'condition') {
                    for (let cindex = 0; cindex < message.condition.length; cindex++) {
                      const condition = message.condition[cindex]
                      nodes[index].answer[aindex][mindex].condition[
                        cindex
                      ].caseText = vm.convertCondition(condition.case)
                    }
                  } else if (message.type == 'api') {
                    var api = vm.apis.find(el => {
                      return el.id == message.api_id
                    })
                    var apiName = api ? api.api_name : ''
                    var apiMethod = api ? api.api_method : ''
                    nodes[index].answer[aindex][mindex].api_name = apiName
                    nodes[index].answer[aindex][mindex].api_method = apiMethod
                  } else if (el.type == 'savevariables') {
                    // var variables = message.update.split(',')
                    // var variableList = vm.formatVariable(variables)
                    // vm.$set(nodes[index].answer[aindex][mindex], 'variables', variableList)
                  } else if (message.type == 'image') {
                    nodes[index].answer[aindex][mindex].messageHeight = vm.imageHeight
                    nodes[index].answer[aindex][mindex].height =
                      nodes[index].answer[aindex][mindex].messageHeight

                    nodes[index].answer[aindex][mindex].image = null
                    var img = null
                    var load = false
                    try {
                      if (
                        this.images &&
                        Object.prototype.hasOwnProperty.call(
                          this.images,
                          nodes[index].answer[aindex][mindex].image_url
                        )
                      ) {
                        img = this.images[nodes[index].answer[aindex][mindex].image_url]
                      } else {
                        this.$set(
                          this.images,
                          nodes[index].answer[aindex][mindex].image_url,
                          await vm.onImageLoad(nodes[index].answer[aindex][mindex].image_url)
                        )
                        img = this.images[nodes[index].answer[aindex][mindex].image_url]
                      }

                      nodes[index].answer[aindex][mindex].image = img
                      load = true
                    } catch (error) {
                      console.warn('load image: ', error)
                    }

                    var scale = 270 / (img && img.width ? img.width : 1)

                    nodes[index].answer[aindex][mindex].scale = {
                      x: scale ? scale : 1,
                      y: scale ? scale : 1
                    }

                    await vm.$nextTick()

                    nodes[index].answer[aindex][mindex].loaded = load
                    nodes[index].answer[aindex][mindex].showImage = false
                    // await vm.$nextTick()
                    // vm.$refs[`node_group_${el.id}`][0].getNode().cache()
                  } else if (message.type == 'generic') {
                    for (let gindex = 0; gindex < message.data.length; gindex++) {
                      if (nodes[index].answer[aindex][mindex].data[gindex].image_url) {
                        nodes[index].answer[aindex][mindex].data[gindex].image = null
                        var img = null
                        var load = false
                        try {
                          if (
                            this.images &&
                            Object.prototype.hasOwnProperty.call(
                              this.images,
                              nodes[index].answer[aindex][mindex].data[gindex].image_url
                            )
                          ) {
                            img = this.images[
                              nodes[index].answer[aindex][mindex].data[gindex].image_url
                            ]
                          } else {
                            this.$set(
                              this.images,
                              nodes[index].answer[aindex][mindex].data[gindex].image_url,
                              await vm.onImageLoad(
                                nodes[index].answer[aindex][mindex].data[gindex].image_url
                              )
                            )
                            img = this.images[
                              nodes[index].answer[aindex][mindex].data[gindex].image_url
                            ]
                          }
                          nodes[index].answer[aindex][mindex].data[gindex].image = img
                          load = true
                        } catch (error) {}

                        var scale = 270 / (img && img.width ? img.width : 1)

                        nodes[index].answer[aindex][mindex].data[gindex].scale = {
                          x: scale ? scale : 1,
                          y: scale ? scale : 1
                        }

                        await vm.$nextTick()

                        nodes[index].answer[aindex][mindex].data[gindex].loaded = load
                        nodes[index].answer[aindex][mindex].data[gindex].showImage = false
                      }
                    }
                  } else if (message.type == 'video' || message.type == 'audio') {
                    nodes[index].answer[aindex][mindex].messageHeight = vm.videoAndAudioHeight

                    nodes[index].answer[aindex][mindex].height =
                      nodes[index].answer[aindex][mindex].messageHeight
                  }
                }
              }
            }
          })
          // for (let index = 0; index < nodes.length; index++) {
          //   const el = nodes[index]

          // }

          await Promise.all(promises)

          vm.nodes = nodes
        } catch (error) {
          console.error(error)
        }

        resolve()
      })
    },
    cacheNode() {
      this.nodes.forEach(el => {
        try {
          this.$refs[`node_group_${el.id}`][0].getNode().cache()
          this.$refs[`node_group_pointer_${el.id}`][0].getNode().cache()
        } catch (error) {}
      })

      this.connections.forEach((el, index) => {
        try {
          this.$refs[`connection_${index}_group`][0].getNode().cache()
        } catch (error) {}
      })
    },
    clearCacheNode() {
      this.nodes.forEach(el => {
        try {
          this.$refs[`node_group_${el.id}`][0].getNode().clearCache()
          this.$refs[`node_group_pointer_${el.id}`][0].getNode().clearCache()
        } catch (error) {
          console.log(error)
        }
      })
      this.connections.forEach((el, index) => {
        try {
          this.$refs[`connection_${index}_group`][0].getNode().clearCache()
        } catch (error) {}
      })
    },
    resizeMessage() {
      var vm = this
      var nodes = cloneDeep(vm.nodes)
      return new Promise(async resolve => {
        vm.clearCacheNode()
        try {
          for (let index = 0; index < nodes.length; index++) {
            const el = nodes[index]
            var positionY = 0
            nodes[index].fill = 'white'
            nodes[index].x = isNaN(nodes[index].x) ? 0 : parseInt(nodes[index].x)

            if (el.type == 'api') {
              nodes[index].fillHeader = vm.$store.state.colorlist.api
            } else if (el.type == 'random') {
              nodes[index].fillHeader = vm.$store.state.colorlist.random
              if (
                el.answer.length > 0 &&
                el.answer[0].length > 0 &&
                el.answer[0][0].to &&
                el.answer[0][0].to.length > 0
              ) {
                nodes[index].height = el.answer[0][0].to.length * 30 + 15
              }
            } else if (el.type == 'flow') {
              vm.$set(nodes[index], 'fillHeader', vm.$store.state.colorlist.flow)
              if (el.answer && el.answer.length > 0 && el.answer[0].length > 0) {
                var flownameHeight = 0
                var intentnameHeight = 0

                if (vm.$refs[`node_flow_${el.id}`] && vm.$refs[`node_flow_${el.id}`].length > 0) {
                  flownameHeight = vm.$refs[`node_flow_${el.id}`][0].getStage().height()
                  nodes[index].answer[0][0].flownameHeight = flownameHeight
                }
                if (
                  vm.$refs[`node_intent_${el.id}`] &&
                  vm.$refs[`node_intent_${el.id}`].length > 0
                ) {
                  intentnameHeight = vm.$refs[`node_intent_${el.id}`][0].getStage().height()
                  nodes[index].answer[0][0].intentnameHeight = intentnameHeight
                }
                nodes[index].height = flownameHeight + intentnameHeight + 15
              }
            } else if (el.type == 'savevariables') {
              vm.$set(nodes[index], 'fillHeader', vm.$store.state.colorlist.savevariables)
              if (
                el.answer.length > 0 &&
                el.answer[0].length > 0 &&
                el.answer[0][0].variables &&
                el.answer[0][0].variables.length > 0
              ) {
                var height = 0
                for (let vindex = 0; vindex < el.answer[0][0].variables.length; vindex++) {
                  if (
                    vm.$refs[`node_variable_${el.id}_${vindex}`] &&
                    vm.$refs[`node_variable_${el.id}_${vindex}`].length > 0
                  ) {
                    var variableHeight = vm.$refs[`node_variable_${el.id}_${vindex}`][0]
                      .getStage()
                      .height()
                    nodes[index].answer[0][0].variables[vindex].height = height
                    height += variableHeight
                  }
                }
                nodes[index].height = (height > 0 ? height : 1) + 15
              }
            } else {
              if (el.type == 'start_node') {
                nodes[index].fillHeader = vm.$store.state.colorlist.start_node
                if (vm.$refs[`node_start_${el.id}`] && vm.$refs[`node_start_${el.id}`].length > 0) {
                  vm.$set(
                    nodes[index],
                    'questionHeight',
                    vm.$refs[`node_start_${el.id}`][0].getStage().height()
                  )
                } else {
                  nodes[index].questionHeight = 0
                }
              } else if (el.type == 'condition') {
                nodes[index].fillHeader = vm.$store.state.colorlist.condition
              }
              if (el.answer.length > 0 && el.answer[0].length > 0) {
                for (let aindex = 0; aindex < el.answer.length; aindex++) {
                  const answer = el.answer[aindex]
                  for (let mindex = 0; mindex < answer.length; mindex++) {
                    const message = answer[mindex]

                    nodes[index].answer[aindex][mindex].y = positionY
                    if (message.type == 'text' || message.type == 'button') {
                      if (
                        vm.$refs[`node_answer_text_${el.id}_${aindex}_${mindex}`] &&
                        vm.$refs[`node_answer_text_${el.id}_${aindex}_${mindex}`].length > 0
                      ) {
                        var height = vm.$refs[`node_answer_text_${el.id}_${aindex}_${mindex}`][0]
                          .getStage()
                          .height()

                        nodes[index].answer[aindex][mindex].messageHeight =
                          height > 50 ? height : 50
                      }
                      if (message.type == 'text') {
                        nodes[index].answer[aindex][mindex].height =
                          nodes[index].answer[aindex][mindex].messageHeight
                      } else if (message.type == 'button') {
                        nodes[index].answer[aindex][mindex].height =
                          nodes[index].answer[aindex][mindex].messageHeight +
                          message.buttons.length * vm.buttonHeight
                      }
                    } else if (message.type == 'image') {
                      // nodes[index].answer[aindex][mindex].showImage = true
                    } else if (message.type == 'generic') {
                      var height = 0
                      for (let gindex = 0; gindex < message.data.length; gindex++) {
                        const generic = message.data[gindex]
                        if (
                          vm.$refs[`node_generic_title_${el.id}_${aindex}_${mindex}_${gindex}`] &&
                          vm.$refs[`node_generic_title_${el.id}_${aindex}_${mindex}_${gindex}`]
                            .length > 0
                        ) {
                          var titleHeight = vm.$refs[
                            `node_generic_title_${el.id}_${aindex}_${mindex}_${gindex}`
                          ][0]
                            .getStage()
                            .height()
                          nodes[index].answer[aindex][mindex].data[gindex].titleHeight = titleHeight
                            ? titleHeight
                            : 0
                        }
                        if (
                          vm.$refs[
                            `node_generic_subtitle_${el.id}_${aindex}_${mindex}_${gindex}`
                          ] &&
                          vm.$refs[`node_generic_subtitle_${el.id}_${aindex}_${mindex}_${gindex}`]
                            .length > 0
                        ) {
                          var subtitleHeight = vm.$refs[
                            `node_generic_subtitle_${el.id}_${aindex}_${mindex}_${gindex}`
                          ][0]
                            .getStage()
                            .height()
                          nodes[index].answer[aindex][mindex].data[
                            gindex
                          ].subtitleHeight = subtitleHeight ? subtitleHeight : 0
                        }
                        var genericHeight =
                          vm.imageHeight +
                          nodes[index].answer[aindex][mindex].data[gindex].titleHeight +
                          nodes[index].answer[aindex][mindex].data[gindex].subtitleHeight

                        genericHeight += generic.buttons.length * vm.buttonHeight

                        nodes[index].answer[aindex][mindex].data[
                          gindex
                        ].genericHeight = genericHeight

                        nodes[index].answer[aindex][mindex].data[gindex].genericMessageHeight =
                          nodes[index].answer[aindex][mindex].data[gindex].titleHeight +
                          nodes[index].answer[aindex][mindex].data[gindex].subtitleHeight

                        height = genericHeight
                      }
                      nodes[index].answer[aindex][mindex].height = height > 0 ? height : 1
                    } else if (message.type == 'condition') {
                      var height = 0

                      for (let cindex = 0; cindex < message.condition.length; cindex++) {
                        const condition = message.condition[cindex]
                        nodes[index].answer[aindex][mindex].condition[
                          cindex
                        ].caseText = vm.convertCondition(condition.case)

                        nodes[index].answer[aindex][mindex].condition[cindex].y =
                          height > 0 ? height : 1

                        if (
                          vm.$refs[
                            `node_answer_condition_${el.id}_${aindex}_${mindex}_${cindex}`
                          ] &&
                          vm.$refs[`node_answer_condition_${el.id}_${aindex}_${mindex}_${cindex}`]
                            .length > 0
                        ) {
                          var conditionHeight = vm.$refs[
                            `node_answer_condition_${el.id}_${aindex}_${mindex}_${cindex}`
                          ][0]
                            .getStage()
                            .height()

                          nodes[index].answer[aindex][mindex].condition[cindex].messageHeight =
                            conditionHeight > 0 ? conditionHeight : 0
                        }

                        height += conditionHeight
                      }
                      nodes[index].answer[aindex][mindex].height = height > 0 ? height : 1
                    }

                    positionY += nodes[index].answer[aindex][mindex].height + 15
                  }
                }
              } else {
                if (
                  vm.$refs[`node_message_empty_${el.id}`] &&
                  vm.$refs[`node_message_empty_${el.id}`].length > 0
                ) {
                  positionY += vm.$refs[`node_message_empty_${el.id}`][0].getStage().height() + 15
                }
              }
              // choices
              if (nodes[index].choices) {
                nodes[index].choices.y = positionY
                for (let cindex = 0; cindex < nodes[index].choices.list.length; cindex++) {
                  if (
                    vm.$refs[`node_choice_text_${el.id}_${cindex}`] &&
                    vm.$refs[`node_choice_text_${el.id}_${cindex}`].length > 0
                  ) {
                    var height = vm.$refs[`node_choice_text_${el.id}_${cindex}`][0]
                      .getStage()
                      .height()
                    var width = vm.$refs[`node_choice_text_${el.id}_${cindex}`][0]
                      .getStage()
                      .width()
                    vm.$set(
                      nodes[index].choices.list[cindex],
                      'messageHeight',
                      height > 0 ? height : 50
                    )
                    vm.$set(
                      nodes[index].choices.list[cindex],
                      'messageWidth',
                      width > 0 ? width : 1
                    )
                    nodes[index].choices.list[cindex].y = positionY
                    nodes[index].choices.list[cindex].height = height > 0 ? height : 1
                    positionY += nodes[index].choices.list[cindex].height + 15
                  }
                }
              }
              // user input
              if (nodes[index].userinput) {
                if (
                  vm.$refs[`node_question_text_${el.id}`] &&
                  vm.$refs[`node_question_text_${el.id}`].length > 0
                ) {
                  var hasUserInput = nodes[index].connected_intents.findIndex(connection => {
                    return connection.type == 'input' && connection.text != '{default}'
                  })
                  nodes[index].userinput.hasUserInput = hasUserInput != -1
                  nodes[index].userinput.y = positionY
                  var height = vm.$refs[`node_question_text_${el.id}`][0].getStage().height()
                  nodes[index].userinput.messageHeight = height > 0 ? height : 50
                  nodes[index].userinput.height = height > 0 ? height : 1
                  positionY += nodes[index].userinput.height + 15
                }
              }
              nodes[index].height = positionY && positionY > 0 ? positionY : vm.nodeHeight
            }
          }
          vm.nodes = nodes
          await vm.$nextTick()
          vm.cacheNode()
          // setTimeout(() => {
          //   vm.showAllImage()
          // }, 3000)
          resolve()
        } catch (error) {
          console.error(error)
        }
      })
    },
    showAllImage() {
      var vm = this
      var nodes = cloneDeep(vm.nodes)
      return new Promise(async resolve => {
        try {
          vm.clearCacheNode()
          for (let index = 0; index < nodes.length; index++) {
            const el = nodes[index]

            if (el.type == 'api') {
            } else if (el.type == 'random') {
            } else if (el.type == 'flow') {
            } else if (el.type == 'savevariables') {
            } else {
              if (el.answer.length > 0 && el.answer[0].length > 0) {
                for (let aindex = 0; aindex < el.answer.length; aindex++) {
                  const answer = el.answer[aindex]
                  for (let mindex = 0; mindex < answer.length; mindex++) {
                    const message = answer[mindex]

                    if (message.type == 'image') {
                      nodes[index].answer[aindex][mindex].showImage = true
                    } else if (message.type == 'generic') {
                      var height = 0
                      for (let gindex = 0; gindex < message.data.length; gindex++) {
                        nodes[index].answer[aindex][mindex].data[gindex].showImage = true
                      }
                    }
                  }
                }
              } else {
              }
            }
          }
          vm.nodes = nodes
          await vm.$nextTick()
          vm.nodes.forEach(el => {
            vm.$refs[`node_group_${el.id}`][0].getNode().cache()
            vm.$refs[`node_group_pointer_${el.id}`][0].getNode().cache()
          })

          resolve()
        } catch (error) {
          console.log(error)
        }
      })
    },
    onImageLoad(url) {
      return new Promise((resolve, reject) => {
        try {
          let img = new Image()
          img.src = url
          img.onload = () => {
            resolve(img)
          }
          img.onerror = () => {
            reject('error')
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    isImage(i) {
      var val =
        i instanceof CSSImageValue ||
        i instanceof SVGImageElement ||
        i instanceof HTMLVideoElement ||
        i instanceof HTMLCanvasElement ||
        i instanceof ImageBitmap ||
        i instanceof OffscreenCanvas ||
        i instanceof window.constructor
      // console.log(val, i)
      // return i instanceof HTMLImageElement
      // return val
      return true
    },
    onZoom(e) {
      // var deltaX = e.evt.deltaX
      // var deltaY = e.evt.deltaY

      // var scrollStep = Math.abs(deltaY * 1)

      // return false
      e.evt.preventDefault()

      if (e.currentTarget) {
        var scaleBy = 1.07
        var stage = e.target.getStage()
        var oldScale = stage.scaleX()

        // stage.cache()

        var mousePointTo = {
          x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
          y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale
        }

        var newScale = e.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy
        stage.scale({ x: newScale, y: newScale })
        this.configKonva.scale = { x: newScale, y: newScale }

        var newPos = {
          x: -(mousePointTo.x - stage.getPointerPosition().x / newScale) * newScale,
          y: -(mousePointTo.y - stage.getPointerPosition().y / newScale) * newScale
        }
        stage.position(newPos)
        stage.batchDraw()
        // stage.clearCache()
      }
    },
    async drawAllConnection() {
      var vm = this
      var count = 0
      var connections = []
      if (vm.connections.length > 0) {
        await this.$nextTick()
        this.connections.forEach((line, index) => {
          try {
            this.$refs[`connection_${index}_group`][0].getNode().clearCache()
          } catch (error) {}
        })
      }
      vm.nodes.map((el, index) => {
        if (
          el.connected_intents &&
          typeof el.connected_intents === 'object' &&
          el.connected_intents.length > 0
        ) {
          el.connected_intents.map((connection, qindex) => {
            if (connection.type == 'input' && connection.text == '{default}') {
              var pointStartName = `node_default_${el.id}`
              if (vm.$refs[pointStartName] && vm.$refs[pointStartName].length > 0) {
                var pointStart = vm.$refs[pointStartName][0]
                var pointEndName = `connections_${connection.to}`
                if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
                  var pointEnd = vm.$refs[pointEndName][0]
                  if (connection.to == el.id) {
                    var points = vm.selfBezierCurveLine([
                      pointStart.getStage().x() -
                        pointStart.getStage().offsetX() +
                        pointStart.getStage().width() / 2,
                      pointStart.getStage().y() -
                        pointStart.getStage().offsetY() +
                        pointStart.getStage().height() / 2,
                      pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                      pointEnd.getStage().y() - pointEnd.getStage().offsetY()
                    ])
                  } else {
                    var points = vm.bezierCurveLine([
                      pointStart.getStage().x() -
                        pointStart.getStage().offsetX() +
                        pointStart.getStage().width() / 2,
                      pointStart.getStage().y() -
                        pointStart.getStage().offsetY() +
                        pointStart.getStage().height() / 2,
                      pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                      pointEnd.getStage().y() - pointEnd.getStage().offsetY()
                    ])
                  }
                  connections.push({
                    id: `${el.id}_default_${connection.to}`,
                    pointStartName: pointStartName,
                    pointEndName: pointEndName,
                    points: points,
                    isHover: false,
                    nodeId: el.id,
                    questionIndex: qindex,
                    strokeColor: '#9e9e9e',
                    strokeWidth: 3,
                    type: connection.type,
                    value: connection.text,
                    isBezier: true,
                    to: connection.to
                  })
                }
              }
            } else if (connection.type == 'input') {
              var pointStartName = `node_${connection.type}_${el.id}`
              if (vm.$refs[pointStartName] && vm.$refs[pointStartName].length > 0) {
                var pointStart = vm.$refs[pointStartName][0]
                var pointEndName = `connections_${connection.to}`
                if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
                  var pointEnd = vm.$refs[pointEndName][0]
                  var points = vm.bezierCurveLine([
                    pointStart.getStage().x() - pointStart.getStage().offsetX(),
                    pointStart.getStage().y() - pointStart.getStage().offsetY(),
                    pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                    pointEnd.getStage().y() - pointEnd.getStage().offsetY()
                  ])
                  connections.push({
                    id: `${el.id}_${connection.type}_${connection.to}_${connection.text}`,

                    pointStartName: pointStartName,
                    pointEndName: pointEndName,
                    nodeId: el.id,
                    questionIndex: qindex,
                    points: points,
                    isHover: false,
                    strokeColor: '#9e9e9e',
                    strokeWidth: 3,
                    type: connection.type,
                    value: connection.text,
                    isBezier: true,
                    to: connection.to
                  })
                }
              }
            } else if (connection.type == 'button') {
              var pointStartName = `node_${connection.type}_${el.id}_${connection.text}`
              if (vm.$refs[pointStartName] && vm.$refs[pointStartName].length > 0) {
                var pointStart = vm.$refs[pointStartName][0]
                var pointEndName = `connections_${connection.to}`
                if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
                  var pointEnd = vm.$refs[pointEndName][0]
                  var points = vm.bezierCurveLine([
                    pointStart.getStage().x() - pointStart.getStage().offsetX(),
                    pointStart.getStage().y() - pointStart.getStage().offsetY(),
                    pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                    pointEnd.getStage().y() - pointEnd.getStage().offsetY()
                  ])
                  connections.push({
                    id: `${el.id}_${connection.type}_${connection.to}_${connection.input}`,
                    pointStartName: pointStartName,
                    pointEndName: pointEndName,
                    points: points,
                    isHover: false,
                    nodeId: el.id,
                    questionIndex: qindex,
                    strokeColor: '#9e9e9e',
                    strokeWidth: 3,
                    type: connection.type,
                    value: connection.text,
                    isBezier: true,
                    to: connection.to
                  })
                }
              }
            } else if (connection.type == 'generic') {
              var pointStartName = `node_${connection.type}_${el.id}_${connection.text}`
              if (vm.$refs[pointStartName] && vm.$refs[pointStartName].length > 0) {
                var pointStart = vm.$refs[pointStartName][0]
                var pointEndName = `connections_${connection.to}`
                if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
                  var pointEnd = vm.$refs[pointEndName][0]
                  var points = vm.bezierCurveLine([
                    pointStart.getStage().x() - pointStart.getStage().offsetX(),
                    pointStart.getStage().y() - pointStart.getStage().offsetY(),
                    pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                    pointEnd.getStage().y() - pointEnd.getStage().offsetY()
                  ])
                  connections.push({
                    id: `${el.id}_${connection.type}_${connection.to}_${connection.text}`,
                    pointStartName: pointStartName,
                    pointEndName: pointEndName,
                    points: points,
                    isHover: false,
                    nodeId: el.id,
                    questionIndex: qindex,
                    strokeColor: '#9e9e9e',
                    strokeWidth: 3,
                    type: connection.type,
                    value: connection.text,
                    isBezier: true,
                    to: connection.to
                  })
                }
              }
            } else if (connection.type == 'random') {
              connection.to.map((random, index) => {
                var pointStartName = `node_${connection.type}_${el.id}_${index}`
                if (
                  random != 0 &&
                  vm.$refs[pointStartName] &&
                  vm.$refs[pointStartName].length > 0
                ) {
                  var pointStart = vm.$refs[pointStartName][0]
                  var pointEndName = `connections_${random}`

                  if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
                    var pointEnd = vm.$refs[pointEndName][0]
                    var points = vm.bezierCurveLine([
                      pointStart.getStage().x() - pointStart.getStage().offsetX(),
                      pointStart.getStage().y() - pointStart.getStage().offsetY(),
                      pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                      pointEnd.getStage().y() - pointEnd.getStage().offsetY()
                    ])
                    connections.push({
                      id: `${el.id}_${connection.type}_${random}_${index}`,
                      pointStartName: pointStartName,
                      pointEndName: pointEndName,
                      points: points,
                      isHover: false,
                      nodeId: el.id,
                      questionIndex: qindex,
                      strokeColor: '#9e9e9e',
                      strokeWidth: 3,
                      type: connection.type,
                      isBezier: true,
                      to: random
                    })
                  }
                }
              })
            } else if (connection.type == 'api' || connection.type == 'savevariables') {
              var pointStartName = `node_${connection.type}_${el.id}`
              if (vm.$refs[pointStartName] && vm.$refs[pointStartName].length > 0) {
                var pointStart = vm.$refs[pointStartName][0]
                var pointEndName = `connections_${connection.to}`
                if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
                  var pointEnd = vm.$refs[pointEndName][0]
                  var points = vm.bezierCurveLine([
                    pointStart.getStage().x() - pointStart.getStage().offsetX(),
                    pointStart.getStage().y() - pointStart.getStage().offsetY(),
                    pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                    pointEnd.getStage().y() - pointEnd.getStage().offsetY()
                  ])

                  connections.push({
                    id: `${el.id}_${connection.type}_${connection.to}`,
                    pointStartName: pointStartName,
                    pointEndName: pointEndName,
                    points: points,
                    isHover: false,
                    nodeId: el.id,
                    questionIndex: qindex,
                    strokeColor: '#9e9e9e',
                    strokeWidth: 3,
                    type: connection.type,
                    isBezier: true,
                    to: connection.to
                  })
                }
              }
            } else if (connection.type == 'condition') {
              connection.condition.map((condition, cindex) => {
                var pointStartName = `node_${connection.type}_${el.id}_${cindex}`
                if (vm.$refs[pointStartName] && vm.$refs[pointStartName].length > 0) {
                  var pointStart = vm.$refs[pointStartName][0]
                  var pointEndName = `connections_${condition.to}`
                  if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
                    var pointEnd = vm.$refs[pointEndName][0]
                    var points = vm.bezierCurveLine([
                      pointStart.getStage().x() - pointStart.getStage().offsetX(),
                      pointStart.getStage().y() - pointStart.getStage().offsetY(),
                      pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                      pointEnd.getStage().y() - pointEnd.getStage().offsetY()
                    ])
                    connections.push({
                      id: `${el.id}_${connection.type}_${condition.to}`,
                      pointStartName: pointStartName,
                      pointEndName: pointEndName,
                      points: points,
                      isHover: false,
                      nodeId: el.id,
                      questionIndex: qindex,
                      strokeColor: '#9e9e9e',
                      strokeWidth: 3,
                      type: connection.type,
                      isBezier: true,
                      to: condition.to
                    })
                  }
                }
              })
            } else if (connection.type == 'quick_reply') {
              var pointStartName = `node_${connection.type}_${el.id}_${connection.text}`
              if (vm.$refs[pointStartName] && vm.$refs[pointStartName].length > 0) {
                var pointStart = vm.$refs[pointStartName][0]
                var pointEndName = `connections_${connection.to}`
                if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
                  var pointEnd = vm.$refs[pointEndName][0]
                  var points = vm.bezierCurveLine([
                    pointStart.getStage().x() - pointStart.getStage().offsetX(),
                    pointStart.getStage().y() - pointStart.getStage().offsetY(),
                    pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                    pointEnd.getStage().y() - pointEnd.getStage().offsetY()
                  ])
                  connections.push({
                    id: `${el.id}_${connection.type}_${connection.to}_${connection.input}`,
                    pointStartName: pointStartName,
                    pointEndName: pointEndName,
                    points: points,
                    isHover: false,
                    nodeId: el.id,
                    questionIndex: qindex,
                    strokeColor: '#9e9e9e',
                    strokeWidth: 3,
                    type: connection.type,
                    value: connection.text,
                    isBezier: true,
                    to: connection.to
                  })
                }
              }
            }
          })
        }
        if (el.type == 'start_node') {
          var pointStartName = `node_start_point_${el.id}`

          if (vm.$refs[pointStartName] && vm.$refs[pointStartName].length > 0) {
            var pointStart = vm.$refs[pointStartName][0]

            var pointEndName = `connections_${el.id}`
            if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
              var pointEnd = vm.$refs[pointEndName][0]
              var points = [
                pointStart.getStage().x() - pointStart.getStage().offsetX(),
                pointStart.getStage().y() - pointStart.getStage().offsetY(),
                pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
                pointEnd.getStage().y() - pointEnd.getStage().offsetY()
              ]
              connections.push({
                id: `${el.id}_start_node_${el.id}`,
                pointStartName: pointStartName,
                pointEndName: pointEndName,
                points: points,
                isHover: false,
                nodeId: el.id,
                questionIndex: 0,
                strokeColor: '#9e9e9e',
                strokeWidth: 3,
                type: 'start_node',
                isBezier: false,
                tension: 0.5,
                to: el.id
              })
            }
          }
        }
      })

      this.drawPersistentConnection()

      vm.connections = connections
      if (vm.connections.length > 0) {
        await this.$nextTick()
        this.connections.forEach((line, index) => {
          try {
            this.$refs[`connection_${index}_group`][0].getNode().cache()
          } catch (error) {}
        })
      }
    },
    drawPersistentConnection() {
      var vm = this
      var start_node = vm.nodes.find(el => {
        return el.type == 'start_node'
      })
      if (start_node) {
        try {
          var keywords = start_node.question.split(',')
          if (
            keywords &&
            keywords.length > 0 &&
            this.persistentMenu &&
            this.persistentMenu.length > 0
          ) {
            var pointEndName = `node_start_point_in_${start_node.id}`
            if (vm.$refs[pointEndName] && vm.$refs[pointEndName].length > 0) {
              this.persistentConnections = this.persistentMenu
                .map((el, index) => {
                  if (el.type == 'postback' && keywords.indexOf(el.payload) != -1) {
                    var pointStartName = `node_persistent_point_${start_node.id}_${index}`
                    if (vm.$refs[pointStartName] && vm.$refs[pointStartName].length > 0) {
                      var pointStart = vm.$refs[pointStartName][0]
                      var pointEnd = vm.$refs[pointEndName][0]
                      var points = [
                        pointStart.getStage().x(),
                        pointStart.getStage().y(),
                        pointEnd.getStage().x(),
                        pointEnd.getStage().y()
                      ]
                      return {
                        id: `${index}_start_node_${el.payload}`,
                        pointStartName: pointStartName,
                        pointEndName: pointEndName,
                        points: points,
                        isHover: false,
                        nodeId: el.id,
                        strokeColor: '#9e9e9e',
                        strokeWidth: 3,
                        isBezier: false,
                        to: el.payload,
                        tension: 0.5
                      }
                    }
                  } else {
                    return null
                  }
                })
                .filter(el => {
                  return el != null
                })
            }
          }
        } catch (error) {
          console.log(error)
          this.persistentConnections = []
        }
      }
    },
    async drawSomeConnection(nodeId) {
      var connections = this.connections
        .map((el, index) => {
          return {
            ...el,
            index: index
          }
        })
        .filter(el => {
          return el.nodeId == nodeId || el.to == nodeId
        })

      if (connections.length > 0) {
        connections.forEach(async line => {
          try {
            this.$refs[`connection_${line.index}_group`][0].getNode().clearCache()
          } catch (error) {}

          var pointStart = this.$refs[line.pointStartName][0]
          var pointEnd = this.$refs[line.pointEndName][0]
          var offsetWidth = 0
          var offsetHeight = 0
          if (line.value && line.value == '{default}') {
            offsetWidth = pointStart.getStage().width() / 2
            offsetHeight = pointStart.getStage().height() / 2
          }
          var points = this.bezierCurveLine([
            pointStart.getStage().x() - pointStart.getStage().offsetX() + offsetWidth,
            pointStart.getStage().y() - pointStart.getStage().offsetY() + offsetHeight,
            pointEnd.getStage().x() - pointEnd.getStage().offsetX(),
            pointEnd.getStage().y() - pointEnd.getStage().offsetY()
          ])

          this.$set(this.connections[line.index], 'points', points)

          await this.$nextTick()

          try {
            this.$refs[`connection_${line.index}_group`][0].getNode().cache()
          } catch (error) {}
        })
      }
      this.drawPersistentConnection()
    },
    onResize() {
      var width = window.innerWidth
      var height = window.innerHeight

      var appHeader = document.getElementById('app_header')
      var sidebarMenu = document.getElementById('sidebar_menu .v-navigation-drawer--open')
      this.maxWidth = width - (sidebarMenu ? sidebarMenu.clientWidth : 0)
      this.maxHeight = height - (appHeader ? appHeader.clientHeight : 0) - 2
      this.$set(this.configKonva, 'height', isNaN(this.maxHeight) ? 0 : this.maxHeight)
      this.$set(this.configKonva, 'width', isNaN(this.maxWidth) ? 0 : this.maxWidth)
    },
    async onDeleteSelectedNode() {
      var selected_nodes = this.nodes.filter(el => {
        return el.isSelect
      })
      if (selected_nodes.length == 0) return
      var result = await this.$swal({
        title: 'Do you want to delete this node?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        var deletePromise = []
        this.$store.dispatch('loading')
        try {
          for (let index = 0; index < selected_nodes.length; index++) {
            const element = selected_nodes[index]
            deletePromise.push(
              this.deleteNode({
                id: element.id
              })
            )
          }
          var response = await Promise.all(deletePromise)
          for (let index = 0; index < response.length; index++) {
            const element = response[index]
            this.clearNode(element)
          }

          await this.$nextTick()
          await this.beforeResizeMessage()
          await this.resizeMessage()
          await this.$nextTick()
          await this.drawAllConnection()
          this.updateSelectArea([])
        } catch (error) {
          console.log(error)
          this.flash('Save Unsuccessful: ' + error.message, 'error', {
            timeout: 3000
          })
        }
        this.$store.dispatch('loading')
      }
    },
    async onDeleteNode() {
      if (this.hoverNode != null) {
        var result = await this.$swal({
          title: 'Do you want to delete this node?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          var data = {
            id: this.nodes[this.hoverNode].id
          }
          this.$store.dispatch('loading')
          try {
            var id = await this.deleteNode(data)
            this.clearNode(id)
            await this.$nextTick()
            await this.beforeResizeMessage()
            await this.resizeMessage()
            await this.$nextTick()
            await this.drawAllConnection()
          } catch (error) {
            console.log(error)
            this.flash('Save Unsuccessful: ' + error.message, 'error', {
              timeout: 3000
            })
          }
          this.$store.dispatch('loading')
        }
      }
    },
    deleteNode(data) {
      var vm = this
      return new Promise((resolve, reject) => {
        api.deleteNode(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.responsecode == 200) {
            resolve(data.id)
          }
        })
      })
    },
    clearNode(id) {
      var vm = this
      var hoverNode = this.nodes.findIndex(el => {
        return el.id == id
      })
      if (id != -1) {
        vm.nodes.map((node, index) => {
          if (node.type == 'random') {
            if (node.answer && node.answer.length > 0 && node.answer[0].length > 0) {
              var toIndex = node.answer[0][0].to.findIndex((to, tindex) => {
                return to == id
              })
              if (toIndex != -1) {
                vm.$set(vm.nodes[index].answer[0][0].to, toIndex, 0)
                vm.$set(vm.nodes[index].connected_intents, 0, vm.nodes[index].answer[0][0])
                vm.$emit('updateNode', { payload: vm.nodes[index], oncomplete: () => {} })
              }
            }
          }
          if (node.type == 'condition') {
            if (node.answer.length > 0 && node.answer[0].length > 0) {
              var toIndex = node.answer[0][0].condition
                .map((condition, tindex) => {
                  return condition.to == id ? tindex : null
                })
                .filter(el => {
                  return el != null
                })
              if (toIndex.length > 1) {
                toIndex.forEach(el => {
                  vm.$set(vm.nodes[index].answer[0][0].condition[el], 'to', 0)
                  vm.$set(vm.nodes[index].connected_intents, 0, vm.nodes[index].answer[0][0])
                  vm.$emit('updateNode', { payload: vm.nodes[el] })
                })
              }
            }
          } else {
            if (node && node.connected_intents.length > 0) {
              try {
                node.connected_intents = JSON.parse(node.connected_intents)
              } catch (error) {}
              var toIndex = -1
              do {
                if (node && node.connected_intents) {
                  toIndex = node.connected_intents.findIndex(connect => {
                    return connect.to == id
                  })
                  if (toIndex != -1) {
                    vm.nodes[index].connected_intents.splice(toIndex, 1)
                    vm.$emit('updateNode', { payload: vm.nodes[index] })
                  }
                } else {
                  toIndex = -1
                }
              } while (toIndex != -1)
            }
          }
        })
        vm.nodes.splice(hoverNode, 1)
      }
    },
    onShowConnection() {
      var vm = this
      if (vm.hoverNode != null) {
        vm.selectedNode = vm.nodes[vm.hoverNode]
        vm.showConnection = true
      }
    },
    onNodeMoveStart(index, e) {
      this.$refs[`node_group_${this.nodes[index].id}`][0].getNode().clearCache()
      this.$refs[`node_group_pointer_${this.nodes[index].id}`][0].getNode().clearCache()
    },
    onNodeMove(index, node) {
      this.nodes[index].x = parseInt(node.target.x().toFixed(0))
      this.nodes[index].y = parseInt(node.target.y().toFixed(0))
      this.drawSomeConnection(this.nodes[index].id)
      this.showDeleteNode = false

      if (this.setTimeoutDeleteNode) {
        clearTimeout(this.setTimeoutDeleteNode)
        this.setTimeoutDeleteNode = null
      }
    },
    onNodeMoveEnd(index, node) {
      if (
        this.$refs[`node_${this.nodes[index].id}`] &&
        this.$refs[`node_${this.nodes[index].id}`].length > 0
      ) {
        this.$emit('onMoveNode', {
          id: this.nodes[index].id,
          x: this.$refs[`node_${this.nodes[index].id}`][0].getStage().x(),
          y: this.$refs[`node_${this.nodes[index].id}`][0].getStage().y()
        })
      }
      this.drawSomeConnection(this.nodes[index].id)
      this.dragItemId = null
      this.$refs[`node_group_${this.nodes[index].id}`][0].getNode().cache()
      this.$refs[`node_group_pointer_${this.nodes[index].id}`][0].getNode().cache()
    },
    onNodeClick(index, node) {
      var vm = this
      if (!this.check_privilege) return false
      vm.selectedNode = vm.nodes[index]
      if (this.onHoldShift) {
        vm.$set(vm.nodes[index], 'isSelect', !vm.nodes[index].isSelect)
        var nodes = this.nodes.filter(node => {
          return node.isSelect
        })
        this.updateSelectArea(nodes)
      } else {
        if (vm.nodes[index].type == 'api') {
          vm.showEditApi = true
        } else if (vm.nodes[index].type == 'random') {
          vm.showEditRandom = true
        } else if (vm.nodes[index].type == 'condition') {
          vm.showEditCondition = true
        } else if (vm.nodes[index].type == 'flow') {
          vm.showEditFlow = true
        } else if (vm.nodes[index].type == 'savevariables') {
          vm.showEditVariable = true
        } else {
          vm.showEditNode = true
        }
      }
    },
    onNodeMouseOver(index, e) {
      if (!this.check_privilege) return false
      this.$refs.stage.getNode().container().style.cursor = 'pointer'
      if (
        this.hoverNode != index &&
        this.hoverNode &&
        this.nodes[this.hoverNode] &&
        this.nodes[this.hoverNode].isHover
      ) {
        this.$set(this.nodes[this.hoverNode], 'isHover', false)
      }
      this.hoverNode = index
      if (this.nodes[this.hoverNode].type != 'start_node') {
        this.$set(this.optionPos, 'x', e.currentTarget.absolutePosition().x)
        this.$set(this.optionPos, 'y', e.currentTarget.absolutePosition().y)
        if (this.check_privilege) {
          this.showDeleteNode = this.configKonva.scale.x >= 0.3

          if (this.setTimeoutDeleteNode) {
            clearTimeout(this.setTimeoutDeleteNode)
            this.setTimeoutDeleteNode = null
          }
        }
      }
      this.$set(this.nodes[index], 'isHover', true)
    },
    onNodeMouseLeave(index, e) {
      var vm = this
      if (!this.check_privilege) return false
      this.$refs.stage.getNode().container().style.cursor = 'default'
      vm.setTimeoutDeleteNode = setTimeout(() => {
        vm.$set(this.nodes[vm.hoverNode], 'isHover', false)
        vm.showDeleteNode = false
      }, 100)
    },
    onDeleteNodeMouseOver() {
      if (this.setTimeoutDeleteNode) {
        clearTimeout(this.setTimeoutDeleteNode)
        this.setTimeoutDeleteNode = null
      }
    },
    onDeleteNodeMouseLeave() {
      var vm = this
      vm.setTimeoutDeleteNode = setTimeout(() => {
        vm.$set(this.nodes[vm.hoverNode], 'isHover', false)
        vm.showDeleteNode = false
      }, 100)
    },
    quadCurveLine(points) {
      var quadWeight = -0.3

      var x1 = points[0]
      var y1 = points[1]

      var x4 = points[2]
      var y4 = points[3]

      var dx = Math.abs(x1 - x4) * quadWeight

      return [x1, y1, x1 - dx, y4 + dx, x4, y4]
    },
    bezierCurveLine(points) {
      var bezierWeight = 0.675

      var x1 = points[0]
      var y1 = points[1]

      var x4 = points[2]
      var y4 = points[3]

      var dx = Math.abs(x1 - x4) * bezierWeight

      if (x1 > x4) {
        var x2 = x1 - dx
        var x3 = x4 + dx
        return [x1, y1, x2, y1, x3, y4, x4, y4]
      } else {
        var x2 = x1 + dx
        var x3 = x4 - dx
        return [x1, y1, x2, y1, x3, y4, x4, y4]
      }
    },
    selfBezierCurveLine(points) {
      var x1 = points[0]
      var y1 = points[1]

      var x2 = points[2] - 150
      var y2 = y1 + 150

      var x3 = points[2] - 150
      var y3 = y1

      var x4 = points[2]
      var y4 = points[3]
      return [x1, y1, x2, y2, x3, y3, x4, y4]
    },
    curveLine(points) {
      var x1 = points[0]
      var y1 = points[1]

      var x4 = points[2]
      var y4 = points[3]

      if (x1 > x4) {
        return [x1, y1, x1, y4, x1, y4, x4, y4]
      } else {
        return [x1, y1, x4, y4, x4, y4, x4, y4]
      }
    },
    hitCheck(shape1, shape2) {
      var s1 = shape1.getClientRect() // use this to get bounding rect for shapes other than rectangles.
      var s2 = shape2.getClientRect()

      // corners of shape 1
      var X = s1.x
      var Y = s1.y
      var A = s1.x + s1.width
      var B = s1.y + s1.height

      // corners of shape 2
      var X1 = s2.x
      var A1 = s2.x + s2.width
      var Y1 = s2.y
      var B1 = s2.y + s2.height

      // Simple overlapping rect collision test
      if (A < X1 || A1 < X || B < Y1 || B1 < Y) {
        return false
      } else {
        return true
      }
    },
    onLineMouseOver(index, e) {
      var vm = this
      if (!this.check_privilege) return false
      vm.selectedConnection = vm.connections[index]
      this.$refs.stage.getNode().container().style.cursor = 'pointer'
      vm.$set(vm.connections[index], 'isHover', true)
      if (vm.connections[index].type == 'input' && vm.connections[index].value != '{default}') {
        vm.$set(
          vm.lineDetail,
          'text',
          vm.connections[index].value ? vm.connections[index].value : ''
        )
      } else {
        var node = vm.nodes.find(node => {
          return node.id == vm.connections[index].nodeId
        })
        if (node) {
          vm.$set(vm.lineDetail, 'text', node.default_text ? node.default_text : '-')
        }
      }

      vm.$set(
        vm.lineDetail,
        'type',
        vm.connections[index].type ? vm.connections[index].type : 'input'
      )
      vm.$set(vm.lineDetail, 'strokeColor', '#61a9de')
      if (
        vm.connections[index].nodeId == vm.connections[index].to &&
        vm.connections[index].type == 'input' &&
        vm.connections[index].value == '{default}'
      ) {
        vm.$set(vm.lineDetail, 'x', vm.connections[index].points[0] - 200)
        vm.$set(vm.lineDetail, 'y', vm.connections[index].points[1] + 60)
      } else {
        vm.$set(
          vm.lineDetail,
          'x',
          (vm.connections[index].points[0] + vm.connections[index].points[6]) / 2
        )
        vm.$set(
          vm.lineDetail,
          'y',
          (vm.connections[index].points[1] + vm.connections[index].points[7]) / 2
        )
      }
      vm.$nextTick(() => {
        vm.$set(vm.lineDetail, 'height', vm.$refs['line_detail'].getStage().height())
        vm.$set(vm.lineDetail, 'width', vm.$refs['line_detail'].getStage().width())
        if (vm.connections[index].type == 'input') {
          vm.showLineDetail = true
        }
      })

      this.showToolConnection = true

      if (this.setTimeoutToolConnection) {
        clearTimeout(this.setTimeoutToolConnection)
        this.setTimeoutToolConnection = null
      }
    },
    onLineMouseLeave(index, e) {
      var vm = this
      if (!this.check_privilege) return false
      vm.$set(vm.connections[index], 'isHover', true)

      vm.setTimeoutToolConnection = setTimeout(() => {
        vm.showToolConnection = false
        vm.$refs.stage.getNode().container().style.cursor = 'default'
        var connectionIndex = 0
        do {
          connectionIndex = vm.connections.findIndex(connection => {
            return connection.isHover
          })
          if (connectionIndex != -1) {
            vm.$set(vm.connections[connectionIndex], 'isHover', false)
          }
        } while (connectionIndex != -1)
      }, 100)
    },
    onLineOptionMouseOver() {
      if (!this.check_privilege) return false
      this.$refs.stage.getNode().container().style.cursor = 'pointer'
      if (this.setTimeoutToolConnection) {
        clearTimeout(this.setTimeoutToolConnection)
        this.setTimeoutToolConnection = null
      }
    },
    onLineOptionMouseLeave() {
      var vm = this
      if (!this.check_privilege) return false
      vm.setTimeoutToolConnection = setTimeout(() => {
        // vm.$set(this.nodes[vm.hoverNode], 'isHover', false)
        vm.$refs.stage.getNode().container().style.cursor = 'default'
        var connectionIndex = 0
        do {
          connectionIndex = vm.connections.findIndex(connection => {
            return connection.isHover
          })
          if (connectionIndex != -1) {
            vm.$set(vm.connections[connectionIndex], 'isHover', false)
          }
        } while (connectionIndex != -1)
        vm.showToolConnection = false
      }, 100)
    }
  },
  watch: {
    async search(newVal, oldVal) {
      if (newVal != oldVal) {
        this.clearCacheNode()
        if (!this.search) {
          this.nodes = this.nodes.map(el => {
            return {
              ...el,
              isSearch: false
            }
          })
        } else {
          this.nodes = this.nodes.map(el => {
            var text = null
            if (el.answer && el.answer.length > 0) {
              text = el.answer[0].find(answer => {
                if (['text', 'button'].includes(answer.type)) {
                  return answer.text.toLowerCase().includes(this.search.toLowerCase())
                } else {
                  return false
                }
              })
            }
            return {
              ...el,
              isSearch: el.intentname.toLowerCase().includes(this.search.toLowerCase()) || text
            }
          })
        }

        await this.$nextTick()
        this.nodes.forEach(el => {
          this.$refs[`node_group_${el.id}`][0].getNode().cache()
          this.$refs[`node_group_pointer_${el.id}`][0].getNode().cache()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/FlowCanvas.vue